import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { SelectCustom } from "../componentes/selectComponent";
import { TablaCompletaGrupos } from "../tablas/tabla_simple_grupos";
import { Form, Space, Row, Col, Button, Upload, message, Checkbox, Modal, Select, Tooltip, Image } from "antd";
import { FaRegEdit, FaRegTrashAlt, FaEye } from "react-icons/fa";
import { manejarError } from "../manejo_errores";
import moment from "moment";
import { HeadersAuth } from "../funciones_utiles";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { SelectCampeonatosResultado } from "../componentes/selectCampeonatoResultado";
import { SelectCustomCarreras } from "../componentes/selectComponentCarrera";
import { InputCustom } from "../componentes/inputComponent";
import { PlusCircleOutlined } from "@ant-design/icons";
import { TablaArmadoGrupos } from "../tablas/tabla_armado_grupo";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { columnsM } from "../tablas/columnsGrupos/columnsArmadoGrupos";
import { Grid } from "antd";

const MODOS = {
  ARMAR_GRUPO: "ARMAR_GRUPO",
  MOSTRAR_TODOS: "MOSTRAR_TODOS",
  ARMAR_GRUPO_CUBIERTAS: "ARMAR_GRUPO_CUBIERTAS",
  MOSTRAR_CUBIERTA_PILOTO: "MOSTRAR_CUBIERTA_PILOTO",
  ARMAR_GRUPO_LICENCIAS: "ARMAR_GRUPO_LICENCIAS",
  ARMAR_GRUPO_PRECINTOS: "ARMAR_GRUPO_PRECINTOS",
  MOSTRAR_PRECINTO_PILOTO: "MOSTRAR_PRECINTO_PILOTO",
};

// motor viaja como {numero, anteriores: [...]} desde /precinto/grupo y
// /precinto/historial-piloto. anteriores es un array (más reciente primero)
// con todos los números que tuvo la pieza antes del vigente dentro de esa
// carrera; vacío si no hubo cambios.
const CAMPOS_PRECINTOS_CON_HISTORIAL = [
  { key: "motor", label: "motor" },
];

const renderCampoConHistorial = (campo) => {
  const estiloCelda = {
    fontSize: "15px",
    padding: "2px 4px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  };

  if (!campo || typeof campo !== "object") {
    return <div style={estiloCelda}>{campo || "-"}</div>;
  }
  const { numero, anteriores } = campo;
  return (
    <div style={estiloCelda}>
      <b>{numero ?? "-"}</b>
      {Array.isArray(anteriores) &&
        anteriores.map((anterior, index) => (
          <div key={index} style={{ fontSize: "13px", color: "#888" }}>
            [<i>*{anterior}</i>]
          </div>
        ))}
    </div>
  );
};

const generarRanking = (datos, puntaje) => {
  const datosConTotales = datos.map((piloto) => {
    const total = puntaje.find((p) => p.id_piloto === piloto.id_piloto);

    return {
      ...piloto,
      // si el back ya manda numero_piloto en datos, lo usás directo;
      // si viene en puntaje también, queda como respaldo.
      numero_piloto: piloto.numero_piloto ?? total?.numero_piloto ?? null,
      puntosTotales: total ? total.puntosTotales : 0,
    };
  });

  // ✅ ¿Hay algún piloto con puntos?
  const hayPuntos = datosConTotales.some((p) => (p.puntosTotales || 0) > 0);

  const ordenados = [...datosConTotales].sort((a, b) => {
    const puntosA = a.puntosTotales || 0;
    const puntosB = b.puntosTotales || 0;

    const numA = Number(a.numero_piloto ?? 0);
    const numB = Number(b.numero_piloto ?? 0);

    if (hayPuntos) {
      // 1) puntos desc
      if (puntosB !== puntosA) return puntosB - puntosA;
      // 2) desempate: numero asc
      return numA - numB;
    }

    // si no hay puntos: numero asc
    return numA - numB;
  });

  return ordenados.map((piloto, index) => ({
    ...piloto,
    orden: index + 1,
  }));
};

export const Grupos = ({ sesion, setAlerta }) => {
  const manejarAlertas = useCallback((tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  }, [setAlerta]);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    nombre_grupo: ""
  })
  const { useBreakpoint } = Grid;
  const [campeonato, setCampeonato] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [categoriasPiloto, setCategoriasPiloto] = useState([]);
  const [fetchDatos, setFetchDatos] = useState([]);
  const [bloquearForm, setBloquearForm] = useState(true);
  const [campeonatoSeleccionado, setCampeonatoSeleccionado] = useState([]);
  const [carrerasFiltradas, setCarrerasFiltradas] = useState([]);
  const [idCarreraSeleccionada, setIdCarreraSeleccionada] = useState("");
  const [idCategoriaSeleccionada, setIdCategoriaSeleccionada] = useState("");
  const [mostrarForm, setMostrarForm] = useState(false);
  const [mostrarFormTotal, setMostrarFormTotal] = useState(false);
  const [asistencia, setAsistencia] = useState(undefined);
  const [modoArmarGrupo, setModoArmarGrupo] = useState(false);
  const [modoArmarGrupoTotal, setModoArmarGrupoTotal] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [todosLosPilotos, setTodosLosPilotos] = useState();
  const [puntaje, setPuntaje] = useState([]);
  const [mostrarTodos, setMostrarTodos] = useState(false);
  const [mostrarGrupo, setMostrarGrupo] = useState(false);
  const [tablaTotal, setTablaTotal] = useState([]);
  const [rankingGlobal, setRankingGlobal] = useState([]);
  const [categoriasSeleccionadas, setCategoriasSeleccionadas] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 30,
  });
  const [invitados, setInvitados] = useState([]);
  const [modalCategoriasVisible, setModalCategoriasVisible] = useState(false);
  const [grupos, setGrupos] = useState([
    {
      id: 1,
      nombre: "",
      pilotosSeleccionados: [],
    },
  ]);
  const [modoVista, setModoVista] = useState(null);
  const [mostrarFormCubiertas, setMostrarFormCubiertas] = useState(false);
  const [modoArmarGrupoCubiertas, setModoArmarGrupoCubiertas] = useState(false);

  const [rankingCubiertas, setRankingCubiertas] = useState([]);
  const [tablaCubiertas, setTablaCubiertas] = useState([]);
  const [asistenciaCubiertas, setAsistenciaCubiertas] = useState(false);
  const [seleccionarTodosCubiertas, setSeleccionarTodosCubiertas] = useState(false);
  const [nombreGrupoCubiertas, setNombreGrupoCubiertas] = useState("");

  const [pilotosSelect, setPilotosSelect] = useState([]);
  const [pilotoSeleccionado, setPilotoSeleccionado] = useState("");
  const [pilotoSeleccionadoNombre, setPilotoSeleccionadoNombre] = useState("");
  const [historialPiloto, setHistorialPiloto] = useState([]);

  // Estados para ARMAR_GRUPO_LICENCIAS
  const [mostrarFormLicencias, setMostrarFormLicencias] = useState(false);
  const [asistenciaLicencias, setAsistenciaLicencias] = useState(false);
  const [seleccionarTodosLicencias, setSeleccionarTodosLicencias] = useState(false);
  const [nombreGrupoLicencias, setNombreGrupoLicencias] = useState("");
  const [rankingLicencias, setRankingLicencias] = useState([]);
  const [tablaLicencias, setTablaLicencias] = useState([]);
  
  // Estados para visualización de licencia deportiva
  const [modalLicenciaVisible, setModalLicenciaVisible] = useState(false);
  const [licenciaSeleccionada, setLicenciaSeleccionada] = useState(null);
  const [pilotoLicenciaSeleccionado, setPilotoLicenciaSeleccionado] = useState(null);
  const [cargandoLicencia, setCargandoLicencia] = useState(false);
  const [generandoPdfLicencia, setGenerandoPdfLicencia] = useState(false);

  // Estados para ARMAR_GRUPO_PRECINTOS y MOSTRAR_PRECINTO_PILOTO
  // (idCategoriaPrecintosSeleccionada se comparte entre ambos modos, igual que idCategoriaSeleccionada en Cubiertas)
  const [idCategoriaPrecintosSeleccionada, setIdCategoriaPrecintosSeleccionada] = useState("");
  const [mostrarFormPrecintos, setMostrarFormPrecintos] = useState(false);
  const [asistenciaPrecintos, setAsistenciaPrecintos] = useState(false);
  const [seleccionarTodosPrecintos, setSeleccionarTodosPrecintos] = useState(false);
  const [nombreGrupoPrecintos, setNombreGrupoPrecintos] = useState("");
  const [rankingPrecintos, setRankingPrecintos] = useState([]);
  const [tablaPrecintos, setTablaPrecintos] = useState([]);

  // Estados para MOSTRAR_PRECINTO_PILOTO
  const [pilotosSelectPrecintos, setPilotosSelectPrecintos] = useState([]);
  const [pilotoSeleccionadoPrecintos, setPilotoSeleccionadoPrecintos] = useState("");
  const [pilotoSeleccionadoPrecintosNombre, setPilotoSeleccionadoPrecintosNombre] = useState("");
  const [historialPrecintosPiloto, setHistorialPrecintosPiloto] = useState([]);

  const screens = useBreakpoint();
  const isMobile = !screens.sm;
  const [mostrarDatosAdicionales, setMostrarDatosAdicionales] = useState(false);

  // console.log("pilotos", pilotoSeleccionado)

  useEffect(() => {
    fetchCampeonato(sesion.id_asociacion);
  }, [sesion.id_asociacion]);

  useEffect(() => {
    if (campeonatoSeleccionado) {
      fetchAsistenciasTotales();
    }
  }, [campeonatoSeleccionado]);

  useEffect(() => { 
    if (idCarreraSeleccionada) {
      fetchAsistenciasTotales();
    }
  }, [idCarreraSeleccionada]);

  const fetchCampeonato = async (id_asociacion) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/campeonato/asociacion/${id_asociacion}`);
      const campeonatosConLabel = response.data.map((c) => ({
        ...c,
        label: `${c.nombre_campeonato} (${c.año})`,
      }));
      setCampeonato(campeonatosConLabel);
      // console.log("datacampeonato", response.data)

      const ultimoCampeonato = response.data.reduce((prev, curr) =>
        prev.año > curr.año || (prev.año === curr.año && prev.id > curr.id) ? prev : curr
      );
      // Establecer el campeonato seleccionado
      setCampeonatoSeleccionado(ultimoCampeonato.id);
      fetchCarreras(id_asociacion, ultimoCampeonato.id)
      fetchAsistenciasTotales();
      
    } catch (error) {
      manejarAlertas("error", "Error al obtener el campeonato");
    };
  };

  // Obtener carreras
  const fetchCarreras = async (id_asociacion, id_campeonato) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/carrera/asociacion/${id_asociacion}`
      );
      // console.log("datacarrera", response.data)
      // console.log("el campeonato seleccionado", campeonatoSeleccionado)
      const filtro = response.data.filter(carrera => carrera.id_campeonato == id_campeonato);
      setCarrerasFiltradas(filtro);
      // console.log("carreras", response.data)
     
    } catch (error) {
      manejarAlertas("error","Error al obtener carreras.");

      console.error("Error al obtener carreras:", error);
    }
  };

  // Obtener categorías por carrera
  const fetchCategoriasPorCarrera = async (id_carrera) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/categorias-por-carrera/${id_carrera}`,
        HeadersAuth
      );
      setCategorias(response.data);

      // console.log("response categorias", response.data)
    } catch (error) {
      manejarAlertas("error","Error al obtener categorías.");
      console.error("Error al obtener categorías:", error);
    }
  };

  const fetchPuntosTotales = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/puntos-totales/${campeonatoSeleccionado}/${idCategoriaSeleccionada}`,
        HeadersAuth
      );
      setPuntaje(response.data);
    } catch (error) {
      console.error("Error al obtener los puntos totales", error)
    }
  }

  // Cargar TODOS los pilotos (ranking global)
  const fetchPilotosCompletos = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/asistencia-filtrar`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_carrera: idCarreraSeleccionada,
            id_categoria: idCategoriaSeleccionada,
            // 🚫 no paso asistencia → traigo todos
          },
          ...HeadersAuth,
        }
      );
      setFetchDatos(response.data);

      if (puntaje.length > 0) {
        const ranking = generarRanking(response.data, puntaje);
        setRankingGlobal(ranking);
        setResultados(ranking); // arranco mostrando todos
      }
    } catch (error) {
      manejarAlertas("error", "Error al obtener pilotos.");
      console.error("Error al obtener pilotos:", error);
    }
  };

  // Filtrar por asistencia (sin recalcular orden)
  const fetchAsistenciasFiltradas = async (asistenciaValue = asistencia) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/asistencia-filtrar`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_carrera: idCarreraSeleccionada,
            id_categoria: idCategoriaSeleccionada,
            ...(asistenciaValue ? { asistencia: "true" } : {}),
          },
          ...HeadersAuth,
        }
      );

      setFetchDatos(response.data);
      // console.log("datos filtrados", response.data)
      fetchInvitados(response.data, campeonatoSeleccionado, idCarreraSeleccionada, idCategoriaSeleccionada)
      if (asistenciaValue) {
        // 🚩 filtro sobre ranking global → mantengo posiciones
        const soloAsistentes = rankingGlobal.filter((p) =>
          response.data.some((r) => r.id_piloto === p.id_piloto)
        );
        setResultados(soloAsistentes);
      } else {
        setResultados(rankingGlobal);
      }
    } catch (error) {
      manejarAlertas("error", "Error al obtener asistencias.");
      console.error("Error al obtener asistencias:", error);
    }
  };

  // 🚩 useEffect inicial: carga ranking global al montar o cuando cambian los filtros
  useEffect(() => {
    if (campeonatoSeleccionado && idCarreraSeleccionada && idCategoriaSeleccionada) {
      fetchPilotosCompletos();
    }
  }, [campeonatoSeleccionado, idCarreraSeleccionada, idCategoriaSeleccionada, puntaje]);

  const fetchAsistenciasTotales = async (asistenciaValue = asistencia) => {
    try {
      // console.log("campeonatoSeleccionado en fetch:", campeonatoSeleccionado);
      // console.log("idCarreraSeleccionada en fetch:", idCarreraSeleccionada);
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/asistencia-total`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            ...(idCarreraSeleccionada ? { id_carrera: idCarreraSeleccionada } : {}),
            ...(asistenciaValue ? { asistencia: "true" } : {}),
          },
          ...HeadersAuth,
        }
      );
      // setFetchDatos(response.data);
      setTablaTotal(response.data);
      // console.log("datassd", response.data);
    } catch (error) {
      manejarAlertas("error", "Error al obtener las asistencias.");
      console.error("Error al obtener asistencias:", error);
    }
  };

  useEffect(() => {
    if (modoVista === MODOS.ARMAR_GRUPO_CUBIERTAS && campeonatoSeleccionado && idCarreraSeleccionada && idCategoriaSeleccionada) {
      fetchAsistenciasFiltradasCubiertas(asistenciaCubiertas);
    }
  }, [modoVista, campeonatoSeleccionado, idCarreraSeleccionada, idCategoriaSeleccionada, asistenciaCubiertas]);

  const fetchAsistenciasFiltradasCubiertas = async (soloAsisten = asistenciaCubiertas) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/asistencia-filtrar-cubiertas`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_carrera: idCarreraSeleccionada,
            id_categoria: idCategoriaSeleccionada,
            ...(soloAsisten ? { asistencia: "true" } : {}),
          },
          ...HeadersAuth,
        }
      );

      if (soloAsisten) {
        const ids = new Set((resp.data || []).map((r) => r.id_piloto));
        const solo = rankingCubiertas.filter((r) => ids.has(r.id_piloto));
        setTablaCubiertas(solo); // mantiene el orden original (orden global)
      } else {
        setTablaCubiertas(rankingCubiertas);
      }
    } catch (error) {
      manejarAlertas("error", "Error al filtrar cubiertas.");
      console.error(error);
    }
  };

  useEffect(() => {
    if (modoVista === MODOS.MOSTRAR_CUBIERTA_PILOTO && campeonatoSeleccionado && idCategoriaSeleccionada) {
      setPilotoSeleccionado("");
      setHistorialPiloto([]);
      fetchPilotosSelectCubiertas();
    }
  }, [modoVista, campeonatoSeleccionado, idCategoriaSeleccionada]);

  useEffect(() => {
    if (modoVista !== MODOS.ARMAR_GRUPO_CUBIERTAS) return;
    if (!campeonatoSeleccionado || !idCarreraSeleccionada || !idCategoriaSeleccionada) return;

    fetchCubiertasCompletas(); // arma ranking + orden
  }, [modoVista, campeonatoSeleccionado, idCarreraSeleccionada, idCategoriaSeleccionada]);

  useEffect(() => {
    if (modoVista !== MODOS.ARMAR_GRUPO_CUBIERTAS) return;
    if (!rankingCubiertas.length) return;

    fetchAsistenciasFiltradasCubiertas(asistenciaCubiertas);
  }, [asistenciaCubiertas, rankingCubiertas, modoVista]);

  const fetchCubiertasCompletas = async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/asistencia-filtrar-cubiertas`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_carrera: idCarreraSeleccionada,
            id_categoria: idCategoriaSeleccionada,
            // 👈 sin asistencia
          },
          ...HeadersAuth,
        }
      );

      // Armamos orden igual que generarRanking pero SIN puntos (o si querés podés usar puntosTotales también)
      const ordenados = [...(resp.data || [])].sort((a, b) => {
        const numA = Number(a.numero_piloto ?? 0);
        const numB = Number(b.numero_piloto ?? 0);
        return numA - numB;
      });

      const ranking = ordenados.map((r, idx) => ({ ...r, orden: idx + 1 }));

      setRankingCubiertas(ranking);
      setTablaCubiertas(ranking); // por defecto muestra todos
    } catch (error) {
      manejarAlertas("error", "Error al obtener cubiertas.");
      console.error(error);
    }
  };

  const fetchPilotosSelectCubiertas = async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/numero-cubierta/pilotos-por-campeonato-categoria`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_categoria: idCategoriaSeleccionada,
          },
          ...HeadersAuth,
        }
      );
      // console.log("resp.data pil", resp.data);
      setPilotosSelect(resp.data || []);
    } catch (e) {
      manejarAlertas("error", "Error al obtener pilotos del campeonato/categoría.");
      console.error(e);
    }
  };

  useEffect(() => {
    if (modoVista !== MODOS.MOSTRAR_CUBIERTA_PILOTO) return;
    if (!campeonatoSeleccionado) return;

    setIdCategoriaSeleccionada("");
    setPilotoSeleccionado("");
    setHistorialPiloto([]);
    setPilotosSelect([]);

    fetchCategoriasPorCampeonato();
  }, [modoVista, campeonatoSeleccionado]);

  useEffect(() => {
    if (modoVista !== MODOS.MOSTRAR_CUBIERTA_PILOTO) return;
    if (!campeonatoSeleccionado || !idCategoriaSeleccionada) return;

    setPilotoSeleccionado("");
    setHistorialPiloto([]);
    fetchPilotosSelectCubiertas();
  }, [modoVista, campeonatoSeleccionado, idCategoriaSeleccionada]);

  useEffect(() => {
    if (modoVista !== MODOS.MOSTRAR_CUBIERTA_PILOTO) return;
    if (!campeonatoSeleccionado || !idCategoriaSeleccionada || !pilotoSeleccionado) return;

    fetchHistorialCubiertasPiloto();
  }, [modoVista, campeonatoSeleccionado, idCategoriaSeleccionada, pilotoSeleccionado]);

  const fetchHistorialCubiertasPiloto = async () => {
    try {
      // console.log("pilotoSeleccionado", pilotoSeleccionado);
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/numero-cubierta-historial-piloto`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_categoria: idCategoriaSeleccionada,
            id_piloto: pilotoSeleccionado
          },
          ...HeadersAuth,
        }
      );

      setHistorialPiloto(resp.data?.historial || []);
    } catch (e) {
      manejarAlertas("error", "Error al obtener historial de cubiertas.");
      console.error(e);
    }
  };

  // ===== ARMAR_GRUPO_PRECINTOS =====
  useEffect(() => {
    if (modoVista !== MODOS.ARMAR_GRUPO_PRECINTOS) return;
    if (!idCarreraSeleccionada || !idCategoriaPrecintosSeleccionada) return;

    fetchGrupoPrecintosCompletas();
  }, [modoVista, idCarreraSeleccionada, idCategoriaPrecintosSeleccionada]);

  useEffect(() => {
    if (modoVista !== MODOS.ARMAR_GRUPO_PRECINTOS) return;
    if (!rankingPrecintos.length) return;

    fetchAsistenciasFiltradasPrecintos(asistenciaPrecintos);
  }, [asistenciaPrecintos, rankingPrecintos, modoVista]);

  const fetchGrupoPrecintosCompletas = async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/precinto/grupo`,
        {
          params: {
            id_carrera: idCarreraSeleccionada,
            id_categorias: [idCategoriaPrecintosSeleccionada],
          },
          ...HeadersAuth,
        }
      );

      setRankingPrecintos(resp.data || []);
      setTablaPrecintos(resp.data || []);
    } catch (error) {
      manejarAlertas("error", "Error al obtener precintos.");
      console.error(error);
    }
  };

  const fetchAsistenciasFiltradasPrecintos = async (soloAsisten = asistenciaPrecintos) => {
    if (!soloAsisten) {
      setTablaPrecintos(rankingPrecintos);
      return;
    }
    try {
      const resp = await axios.get(`${process.env.REACT_APP_DOMINIO}/asistencia-filtrar`, {
        params: {
          id_campeonato: campeonatoSeleccionado,
          id_carrera: idCarreraSeleccionada,
          id_categoria: idCategoriaPrecintosSeleccionada,
          asistencia: "true",
        },
        ...HeadersAuth,
      });

      const idsAsisten = new Set((resp.data || []).map((p) => p.id_piloto));
      setTablaPrecintos(rankingPrecintos.filter((r) => idsAsisten.has(r.id_piloto)));
    } catch (error) {
      manejarAlertas("error", "Error al filtrar precintos.");
      console.error(error);
    }
  };

  // ===== MOSTRAR_PRECINTO_PILOTO =====
  useEffect(() => {
    if (modoVista !== MODOS.MOSTRAR_PRECINTO_PILOTO) return;
    if (!campeonatoSeleccionado) return;

    setIdCategoriaPrecintosSeleccionada("");
    setPilotoSeleccionadoPrecintos("");
    setPilotoSeleccionadoPrecintosNombre("");
    setHistorialPrecintosPiloto([]);
    setPilotosSelectPrecintos([]);

    fetchCategoriasPorCampeonato();
  }, [modoVista, campeonatoSeleccionado]);

  useEffect(() => {
    if (modoVista !== MODOS.MOSTRAR_PRECINTO_PILOTO) return;
    if (!campeonatoSeleccionado || !idCategoriaPrecintosSeleccionada) return;

    setPilotoSeleccionadoPrecintos("");
    setPilotoSeleccionadoPrecintosNombre("");
    fetchPilotosSelectPrecintos();
  }, [modoVista, campeonatoSeleccionado, idCategoriaPrecintosSeleccionada]);

  useEffect(() => {
    if (modoVista !== MODOS.MOSTRAR_PRECINTO_PILOTO) return;
    if (!campeonatoSeleccionado || !idCategoriaPrecintosSeleccionada || !pilotoSeleccionadoPrecintos) return;

    fetchHistorialPrecintosPiloto();
  }, [modoVista, campeonatoSeleccionado, idCategoriaPrecintosSeleccionada, pilotoSeleccionadoPrecintos]);

  const fetchPilotosSelectPrecintos = async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/precinto/pilotos-por-campeonato-categoria`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_categoria: idCategoriaPrecintosSeleccionada,
          },
          ...HeadersAuth,
        }
      );
      setPilotosSelectPrecintos(resp.data || []);
    } catch (e) {
      manejarAlertas("error", "Error al obtener pilotos del campeonato/categoría.");
      console.error(e);
    }
  };

  const fetchHistorialPrecintosPiloto = async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/precinto/historial-piloto`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_categoria: idCategoriaPrecintosSeleccionada,
            id_piloto: pilotoSeleccionadoPrecintos,
          },
          ...HeadersAuth,
        }
      );

      setHistorialPrecintosPiloto(resp.data?.historial || []);
    } catch (e) {
      manejarAlertas("error", "Error al obtener historial de precintos.");
      console.error(e);
    }
  };

  const fetchLicenciasCompletas = useCallback(async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/asistencia-filtrar`,
        {
          params: {
            id_campeonato: campeonatoSeleccionado,
            id_carrera: idCarreraSeleccionada,
            id_categoria: idCategoriaSeleccionada,
          },
          ...HeadersAuth,
        }
      );

      const puntajeResp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/puntos-totales/${campeonatoSeleccionado}/${idCategoriaSeleccionada}`,
        HeadersAuth
      ).catch(() => ({ data: [] }));

      let ranking = generarRanking(resp.data || [], puntajeResp.data || []);

      setRankingLicencias(ranking);
      setTablaLicencias(ranking);
    } catch (error) {
      manejarAlertas("error", "Error al obtener pilotos de licencias.");
      console.error(error);
    }
  }, [
    campeonatoSeleccionado,
    idCarreraSeleccionada,
    idCategoriaSeleccionada,
    manejarAlertas,
  ]);

  const aplicarFiltrosLicencias = useCallback(() => {
    let datos = [...rankingLicencias];
    if (asistenciaLicencias) {
      datos = datos.filter((p) => p.asistencia === true || p.asistencia === 1);
    }
    setTablaLicencias(datos);
  }, [rankingLicencias, asistenciaLicencias]);

  // ── ARMAR_GRUPO_LICENCIAS ──────────────────────────────────────────
  useEffect(() => {
    if (modoVista !== MODOS.ARMAR_GRUPO_LICENCIAS) return;
    if (!campeonatoSeleccionado || !idCarreraSeleccionada || !idCategoriaSeleccionada) return;
    fetchLicenciasCompletas();
  }, [
    modoVista,
    campeonatoSeleccionado,
    idCarreraSeleccionada,
    idCategoriaSeleccionada,
    fetchLicenciasCompletas,
  ]);

  useEffect(() => {
    if (modoVista !== MODOS.ARMAR_GRUPO_LICENCIAS) return;
    if (!rankingLicencias.length) return;
    aplicarFiltrosLicencias();
  }, [modoVista, rankingLicencias, aplicarFiltrosLicencias]);

  const handleAbrirLicencia = async (record) => {
    const idCampeonatoLicencia =
      record.id_campeonato ||
      record.carrera?.id_campeonato ||
      campeonatoSeleccionado;

    if (!record.id_piloto || !sesion?.id_asociacion || !idCampeonatoLicencia) {
      manejarAlertas("error", "Faltan datos para consultar la licencia.");
      return;
    }

    setLicenciaSeleccionada(null);
    setPilotoLicenciaSeleccionado({
      nombre: record.piloto?.nombre,
      apellido: record.piloto?.apellido,
      dni: record.piloto?.dni,
      id_piloto: record.id_piloto,
      id_campeonato: idCampeonatoLicencia,
    });
    setCargandoLicencia(true);
    setModalLicenciaVisible(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/licencias-deportivas/${record.id_piloto}/${sesion.id_asociacion}/${idCampeonatoLicencia}`,
        HeadersAuth
      );

      const licencia = response?.data?.licencia;
      const licenciaValida =
        licencia &&
        typeof licencia === "object" &&
        !Array.isArray(licencia) &&
        ((licencia.tipo_archivo === "IMAGENES" && (licencia.foto_frente || licencia.foto_dorso)) ||
          (licencia.tipo_archivo === "PDF" && licencia.licencia_pdf));

      if (response.status === 200 && licenciaValida) {
        setLicenciaSeleccionada(licencia);
      } else {
        manejarAlertas("error", "No se encontraron datos de la licencia.");
        setLicenciaSeleccionada(null);
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        manejarAlertas("error", "No se encontraron datos de la licencia.");
      } else {
        manejarAlertas("error", manejarError(error));
      }
      setLicenciaSeleccionada(null);
    } finally {
      setCargandoLicencia(false);
    }
  };

  const handleCerrarLicencia = () => {
    setModalLicenciaVisible(false);
    setLicenciaSeleccionada(null);
    setPilotoLicenciaSeleccionado(null);
    setCargandoLicencia(false);
    setGenerandoPdfLicencia(false);
  };

  const generarPdfLicencia = async () => {
    if (!licenciaSeleccionada || !pilotoLicenciaSeleccionado) return;
    if (generandoPdfLicencia) return;

    try {
      setGenerandoPdfLicencia(true);

      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();

      // Helper: cargar imagen como base64 desde URL
      const getBase64Image = async (url) => {
        const res = await fetch(url);
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      };

      // Helper: normalizar imagen respetando orientación EXIF del navegador
      const normalizarImagen = (url) => {
        return new Promise((resolve, reject) => {
          const img = new window.Image();
          img.crossOrigin = "anonymous";
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const dataUrl = canvas.toDataURL("image/jpeg", 0.92);
            resolve({ base64: dataUrl, ancho: img.naturalWidth, alto: img.naturalHeight });
          };
          img.onerror = () => reject(new Error(`No se pudo cargar la imagen: ${url}`));
          img.src = url;
        });
      };

      // Obtener datos de la asociación
      const responseAsociacion = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/asociacion-detalles/${sesion.id_asociacion}`
      );
      const nombreAsociacion = responseAsociacion.data.nombre || "Asociación";
      const imagenAsociacion = responseAsociacion.data.imagen;

      // Encabezado: Logo y nombre de la asociación (igual al PDF grupal)
      let logoUrl = imagenAsociacion && imagenAsociacion !== "null"
        ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/ASOCIACIONES/${imagenAsociacion}`
        : "/img/logo-mundo-piloto.png";

      let logoBase64 = null;
      try {
        logoBase64 = await getBase64Image(logoUrl);
      } catch (e) {
        console.error("Error al cargar logo:", e);
      }

      // Fondo del encabezado (igual al grupal)
      doc.setFillColor(220, 220, 220);
      doc.rect(10, 10, pageWidth - 20, 30, "F");

      // Logo (mismas medidas que el grupal: 35×24)
      if (logoBase64) {
        doc.addImage(logoBase64, "PNG", 15, 13, 35, 24);
      }

      // Nombre de la asociación (igual al grupal: bold, 16, y=20)
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(nombreAsociacion.toUpperCase(), pageWidth / 2, 20, { align: "center" });

      // Nombre del piloto (ocupa el lugar del título del grupo: bold, 16, y=28)
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(
        `${pilotoLicenciaSeleccionado.apellido}, ${pilotoLicenciaSeleccionado.nombre}`.toUpperCase(),
        pageWidth / 2,
        28,
        { align: "center" }
      );

      // Procesar imágenes con normalización EXIF y proporciones correctas
      if (licenciaSeleccionada.tipo_archivo === "IMAGENES") {
        let imagenes = [];

        if (licenciaSeleccionada.foto_frente) {
          const urlFrente = `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${pilotoLicenciaSeleccionado.id_campeonato || campeonatoSeleccionado}/piloto_${pilotoLicenciaSeleccionado.id_piloto}/${licenciaSeleccionada.foto_frente}`;
          try {
            const normalizado = await normalizarImagen(urlFrente);
            imagenes.push({ ...normalizado, etiqueta: "Frente" });
          } catch (e) {
            manejarAlertas("error", "No se pudo cargar la imagen del frente de la licencia.");
            setGenerandoPdfLicencia(false);
            return;
          }
        }

        if (licenciaSeleccionada.foto_dorso) {
          const urlDorso = `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${pilotoLicenciaSeleccionado.id_campeonato || campeonatoSeleccionado}/piloto_${pilotoLicenciaSeleccionado.id_piloto}/${licenciaSeleccionada.foto_dorso}`;
          try {
            const normalizado = await normalizarImagen(urlDorso);
            imagenes.push({ ...normalizado, etiqueta: "Dorso" });
          } catch (e) {
            manejarAlertas("error", "No se pudo cargar la imagen del dorso de la licencia.");
            setGenerandoPdfLicencia(false);
            return;
          }
        }

        if (imagenes.length > 0) {
          let currentY = 50;
          const marginX = 10;
          const colWidth = (pageWidth - marginX * 2 - 5) / 2;
          const maxHeight = 100;

          if (imagenes.length === 2) {
            const im1 = imagenes[0];
            const im2 = imagenes[1];

            // Etiquetas
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text(im1.etiqueta, marginX + colWidth / 2, currentY, { align: "center" });
            doc.text(im2.etiqueta, marginX + colWidth + 5 + colWidth / 2, currentY, { align: "center" });
            currentY += 4;

            // Frente — calcular proporciones conservando aspecto
            const escala1 = Math.min(colWidth / im1.ancho, maxHeight / im1.alto);
            const af1 = im1.ancho * escala1;
            const hf1 = im1.alto * escala1;
            const xFrente = marginX + (colWidth - af1) / 2;
            doc.addImage(im1.base64, "JPEG", xFrente, currentY, af1, hf1);

            // Dorso — calcular proporciones conservando aspecto
            const escala2 = Math.min(colWidth / im2.ancho, maxHeight / im2.alto);
            const af2 = im2.ancho * escala2;
            const hf2 = im2.alto * escala2;
            const xDorso = marginX + colWidth + 5 + (colWidth - af2) / 2;
            doc.addImage(im2.base64, "JPEG", xDorso, currentY, af2, hf2);

            currentY += maxHeight + 5;
          } else {
            // Imagen única — centrada con ancho mayor pero proporcional
            const im = imagenes[0];
            const maxWide = Math.min(colWidth * 1.5, pageWidth - marginX * 2);
            const maxH = 120;
            const escala = Math.min(maxWide / im.ancho, maxH / im.alto);
            const af = im.ancho * escala;
            const hf = im.alto * escala;
            const xImg = (pageWidth - af) / 2;

            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text(im.etiqueta, pageWidth / 2, currentY, { align: "center" });
            currentY += 4;

            doc.addImage(im.base64, "JPEG", xImg, currentY, af, hf);
            currentY += hf + 5;
          }
        }
      }

      const nombreArchivo = `licencia-${pilotoLicenciaSeleccionado.apellido}-${pilotoLicenciaSeleccionado.nombre}`.replace(/\s+/g, "-");
      doc.save(`${nombreArchivo}.pdf`);

      manejarAlertas("success", "PDF de licencia descargado correctamente.");
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    } finally {
      setGenerandoPdfLicencia(false);
    }
  };

  // ── FIN ARMAR_GRUPO_LICENCIAS ──────────────────────────────────────

  const fetchCategoriasPorCampeonato = async () => {
    try {
      // console.log("campoe", campeonatoSeleccionado)
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/categoria-por-campeonato`,
        {
          params: { id_campeonato: campeonatoSeleccionado },
          ...HeadersAuth,
        }
      );
      // console.log("resp.data", resp.data);
      setCategoriasPiloto(resp.data || []);
    } catch (e) {
      manejarAlertas("error", "Error al obtener categorías del campeonato.");
      console.error("ERROR categorias por campeonato:", e?.response?.data || e.message);
    }
  };

  const handleCategoriaChangeSoloCubiertas = (e) => {
    const val = e.target.value;
    setIdCategoriaSeleccionada(val);
    setPilotoSeleccionado("");
    setHistorialPiloto([]);
  };

  const handleCategoriaPrecintosPilotoChange = (e) => {
    const val = e.target.value;
    setIdCategoriaPrecintosSeleccionada(val);
    setPilotoSeleccionadoPrecintos("");
    setPilotoSeleccionadoPrecintosNombre("");
    setHistorialPrecintosPiloto([]);
  };

  const handleCategoriaPrecintosChange = (e) => {
    const idCategoria = e.target.value;
    setIdCategoriaPrecintosSeleccionada(idCategoria);

    setAsistenciaPrecintos(false);
    setSeleccionarTodosPrecintos(false);
  };

  const handleGrupoCubiertas = (bool) => {
    // bool = true significa entrar a ese modo
    // usamos tu patrón: cuando entro a un modo, apago el otro
    setMostrarGrupo(false);
    setMostrarTodos(false);

    // podés crear estados nuevos si querés, por ahora alcanzan estos:
    // setMostrarGrupoCubiertas(bool) <- si lo querés explícito

    // reseteos como ya hacés:
    setMostrarForm("");
    setModoArmarGrupo("");
    setAsistencia("");
    fetchAsistenciasFiltradas("");
    fetchAsistenciasTotales("");
    setTempDatosFormulario("");
    setTodosLosPilotos("");
    setIdCarreraSeleccionada("");
    setIdCategoriaSeleccionada("");

    // y si necesitás limpiar cosas específicas:
    setCategoriasSeleccionadas([]);
    setGrupos([{ id: 1, nombre: "", pilotosSeleccionados: [] }]);
  };

  const handleGrupoLicencias = (bool) => {
    setMostrarGrupo(false);
    setMostrarTodos(false);
    setMostrarForm("");
    setModoArmarGrupo("");
    setAsistencia("");
    fetchAsistenciasFiltradas("");
    fetchAsistenciasTotales("");
    setTempDatosFormulario("");
    setTodosLosPilotos("");
    setIdCarreraSeleccionada("");
    setIdCategoriaSeleccionada("");
    setCategoriasSeleccionadas([]);
    setGrupos([{ id: 1, nombre: "", pilotosSeleccionados: [] }]);
    // reset licencias
    setMostrarFormLicencias(false);
    setAsistenciaLicencias(false);
    setSeleccionarTodosLicencias(false);
    setNombreGrupoLicencias("");
    setRankingLicencias([]);
    setTablaLicencias([]);
  };

  const handleMostrarCubiertaPiloto = (bool) => {
    setMostrarGrupo(false);
    setMostrarTodos(false);

    // reseteos
    setMostrarForm(false);
    setMostrarFormTotal(false);
    setModoArmarGrupo(false);
    setModoArmarGrupoTotal(false);

    setAsistencia("");
    fetchAsistenciasFiltradas("");
    fetchAsistenciasTotales("");

    setTempDatosFormulario("");
    setTodosLosPilotos("");
    setCategoriasSeleccionadas([]);

    // si querés que arranque “limpio”
    setIdCarreraSeleccionada("");
    setIdCategoriaSeleccionada("");

    // acá después vas a setear el piloto seleccionado + abrir modal, etc.
  };

  const handleGrupoPrecintos = (bool) => {
    setMostrarGrupo(false);
    setMostrarTodos(false);
    setMostrarForm("");
    setModoArmarGrupo("");
    setAsistencia("");
    fetchAsistenciasFiltradas("");
    fetchAsistenciasTotales("");
    setTempDatosFormulario("");
    setTodosLosPilotos("");
    setIdCarreraSeleccionada("");
    setIdCategoriaSeleccionada("");
    setCategoriasSeleccionadas([]);
    setGrupos([{ id: 1, nombre: "", pilotosSeleccionados: [] }]);
    // reset precintos
    setMostrarFormPrecintos(false);
    setAsistenciaPrecintos(false);
    setSeleccionarTodosPrecintos(false);
    setNombreGrupoPrecintos("");
    setIdCategoriaPrecintosSeleccionada("");
    setRankingPrecintos([]);
    setTablaPrecintos([]);
  };

  const handleMostrarPrecintoPiloto = (bool) => {
    setMostrarGrupo(false);
    setMostrarTodos(false);

    setMostrarForm(false);
    setMostrarFormTotal(false);
    setModoArmarGrupo(false);
    setModoArmarGrupoTotal(false);

    setAsistencia("");
    fetchAsistenciasFiltradas("");
    fetchAsistenciasTotales("");

    setTempDatosFormulario("");
    setTodosLosPilotos("");
    setCategoriasSeleccionadas([]);

    setIdCarreraSeleccionada("");
    setIdCategoriaPrecintosSeleccionada("");
    setPilotoSeleccionadoPrecintos("");
    setPilotoSeleccionadoPrecintosNombre("");
    setPilotosSelectPrecintos([]);
    setHistorialPrecintosPiloto([]);
  };

  const onChangeModoVista = (value) => {
    setModoVista(value);

    // Cancelar lo que corresponda y entrar al modo elegido
    switch (value) {
      case MODOS.ARMAR_GRUPO:
        handleTodos(false);
        handleGrupo(true);
        break;

      case MODOS.MOSTRAR_TODOS:
        handleGrupo(false);
        handleTodos(true);
        break;

      case MODOS.ARMAR_GRUPO_CUBIERTAS:
        handleGrupo(false);
        handleTodos(false);
        handleGrupoCubiertas(true);
        break;

      case MODOS.MOSTRAR_CUBIERTA_PILOTO:
        handleGrupo(false);
        handleTodos(false);
        handleMostrarCubiertaPiloto(true);
        break;

      case MODOS.ARMAR_GRUPO_LICENCIAS:
        handleGrupo(false);
        handleTodos(false);
        handleGrupoLicencias(true);
        break;

      case MODOS.ARMAR_GRUPO_PRECINTOS:
        handleGrupo(false);
        handleTodos(false);
        handleGrupoPrecintos(true);
        break;

      case MODOS.MOSTRAR_PRECINTO_PILOTO:
        handleGrupo(false);
        handleTodos(false);
        handleMostrarPrecintoPiloto(true);
        break;

      default:
        break;
    }
  };



    //manejo de select-campeonato
  const handleCampeonatoChange = (e,id_asociacion) => {
    const idCampeonato = e.target.value;
    setCampeonatoSeleccionado(idCampeonato);
    setIdCarreraSeleccionada(null);
    if (modoVista === MODOS.ARMAR_GRUPO_LICENCIAS) {
      setRankingLicencias([]);
      setTablaLicencias([]);
      setSeleccionarTodosLicencias(false);
    }
    if (modoVista === MODOS.ARMAR_GRUPO_PRECINTOS) {
      setIdCategoriaPrecintosSeleccionada("");
      setRankingPrecintos([]);
      setTablaPrecintos([]);
    }
    fetchCarreras(id_asociacion,idCampeonato)
  };

  useEffect(() => {
    if (idCategoriaSeleccionada && idCarreraSeleccionada && campeonatoSeleccionado) {
      fetchAsistenciasFiltradas();
      fetchAsistenciasTotales();
      fetchPuntosTotales();
    }
  }, [sesion.id_asociacion, campeonatoSeleccionado, idCategoriaSeleccionada, idCarreraSeleccionada]);

  // Manejo del cambio en el select de carreras
  const handleCarreraChange = (e) => {
    const idCarrera = e.target.value;
    setIdCarreraSeleccionada(idCarrera);
    setIdCategoriaSeleccionada(null); // Reiniciar categoría al cambiar de carrera
    setFetchDatos([]);
    setCategoriasSeleccionadas([]);
    if (modoVista === MODOS.ARMAR_GRUPO_LICENCIAS) {
      setRankingLicencias([]);
      setTablaLicencias([]);
      setSeleccionarTodosLicencias(false);
    }
    if (modoVista === MODOS.ARMAR_GRUPO_PRECINTOS) {
      setIdCategoriaPrecintosSeleccionada(""); // Reiniciar categoría al cambiar de carrera
      setRankingPrecintos([]);
      setTablaPrecintos([]);
    }
    setBloquearForm(true);
    if (idCarrera) {
      fetchCategoriasPorCarrera(idCarrera); // Cargar categorías para la carrera seleccionada
    }
  };

  const handleCarreraChangeTotal = (e) => {
    const idCarrera = e.target.value;
    setIdCarreraSeleccionada(idCarrera);
    setFetchDatos([]); 
    
    setBloquearForm(true);
    mostrarFormularioTotal(false, false);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setTempDatosFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const onChange = (e) => {
    const nuevaAsistencia = e.target.checked;
    setAsistencia(nuevaAsistencia);
    fetchAsistenciasFiltradas(nuevaAsistencia);
    fetchAsistenciasTotales(nuevaAsistencia);
  };

  const onChangePilotos = (e) => {
    const todos = e.target.checked;
    setTodosLosPilotos(todos)
  };

  const onChangeAdicional = (e) => {
    setMostrarDatosAdicionales(e.target.checked);
  };

  const onChangeCategoria = (e, categoria) => {
    setCategoriasSeleccionadas((prev) => {
      if (e.target.checked) {
        // Si la categoría no está, la agregamos al final
        if (!prev.some((c) => c.id === categoria.id)) {
          return [...prev, categoria];
        }
        return prev;
      } else {
        // Si se desmarca, la quitamos
        return prev.filter((c) => c.id !== categoria.id);
      }
    });
  };

  const handlePaginationChange = (page, pageSize) => {
    setPagination({ current: page, pageSize });
  };

  // Manejo del cambio en el select de categorías
  const handleCategoriaChange = (e) => {
    const idCategoria = e.target.value;
    setIdCategoriaSeleccionada(idCategoria);

    // ✅ NO cierres el armado. Solo limpiá lo que te interese:
    setAsistencia(undefined);
    setTodosLosPilotos(false);
    if (modoVista === MODOS.ARMAR_GRUPO_LICENCIAS) {
      setSeleccionarTodosLicencias(false);
    }

    // Si querés que al cambiar categoría se borren selecciones de pilotos (recomendado):
    setGrupos([{ id: 1, nombre: "", pilotosSeleccionados: [] }]);
  };
  
  const mostrarFormularioHandler = (form, grupo) => {
    setMostrarForm(form);
    setModoArmarGrupo(grupo);

    setAsistencia("");
    // setCategoriasSeleccionadas([]);
    fetchAsistenciasFiltradas("");
    fetchAsistenciasTotales("");
    setTempDatosFormulario("");
    setTodosLosPilotos("");
    setGrupos([
      {
        id: 1,
        nombre: "",
        pilotosSeleccionados: [],
      },
    ]);
  };

  const mostrarFormularioTotal = (form, grupo) => {
    setMostrarFormTotal(form);
    setModoArmarGrupoTotal(grupo);

    setAsistencia("");
    fetchAsistenciasFiltradas("");
    fetchAsistenciasTotales("");
    setTempDatosFormulario("");
    setTodosLosPilotos("");
  };

  const handleFormCubiertas = (form) => {
    setMostrarFormCubiertas(form);

    setNombreGrupoCubiertas("");
    setAsistenciaCubiertas("");
    setSeleccionarTodosCubiertas("");
  }

  const handlePilotoChange = (e) => {
    const idPiloto = e.target.value;

    setPilotoSeleccionado(idPiloto);

    const piloto = pilotosSelect.find(p => p.id === Number(idPiloto));

    if (piloto) {
      setPilotoSeleccionadoNombre(piloto.label);
    }
  };

  const handleFormPrecintos = (form) => {
    setMostrarFormPrecintos(form);

    setNombreGrupoPrecintos("");
    setAsistenciaPrecintos(false);
    setSeleccionarTodosPrecintos(false);
  };

  const handlePilotoPrecintosChange = (e) => {
    const idPiloto = e.target.value;

    setPilotoSeleccionadoPrecintos(idPiloto);

    const piloto = pilotosSelectPrecintos.find((p) => p.id === Number(idPiloto));

    if (piloto) {
      setPilotoSeleccionadoPrecintosNombre(piloto.label);
    }
  };

  const handleTodos = (bool) => {
    setMostrarTodos(bool);

    setModoArmarGrupoTotal("");
    setMostrarFormTotal("");
    setAsistencia("");
    fetchAsistenciasFiltradas("");
    fetchAsistenciasTotales("");
    setTempDatosFormulario("");
    setTodosLosPilotos("");
    setIdCarreraSeleccionada("");
    setIdCategoriaSeleccionada("");
  };

  const handleGrupo = (bool) => {
    setMostrarGrupo(bool);
    setMostrarTodos(false);

    setMostrarForm("");
    setModoArmarGrupo("");
    setAsistencia("");
    fetchAsistenciasFiltradas("");
    fetchAsistenciasTotales("");
    setTempDatosFormulario("");
    setTodosLosPilotos("");
    setIdCarreraSeleccionada("");
    setIdCategoriaSeleccionada("");
  
  }

  const fetchInvitados = async (datos, id_campeonato, id_carrera, id_categoria) => {
    const datosFiltrados = datos.filter(
      (dato) => dato.carrera.id_campeonato == id_campeonato && dato.id_carrera == id_carrera && dato.id_categoria == id_categoria && dato.pilotoInvitado !== null
    );
    // console.log("datos filtrados", datosFiltrados)
    setInvitados(datosFiltrados);
  }

  const exportarPDFGrupos = async () => {
    const gruposValidos = grupos.filter(
      (g) => g.pilotosSeleccionados.length > 0
    );
    if (!gruposValidos.length) {
      manejarAlertas("error", "Debe seleccionar al menos un piloto por grupo para descargar el pdf.");
      return
    };

    // 🔹 INICIALIZAR PDF (ESTO FALTABA)
    const doc = new jsPDF("p", "mm", "a4");

    const fecha = moment().format("DD/MM/YYYY");

    /* =========================
      DATOS DE ASOCIACIÓN
      ========================= */
    let asociacionesData;
    const response = await axios.get(
      `${process.env.REACT_APP_DOMINIO}/asociacion-detalles/${sesion.id_asociacion}`
    );

    if (response.status === 200) {
      asociacionesData = response.data;
    }

    const nombreAsociacion = asociacionesData.nombre;
    const titulo = "Armado de grupos";

    let nombreCategorias = "";
    if (idCategoriaSeleccionada) {
      try {
        const responseCategoria = await axios.get(
          `${process.env.REACT_APP_DOMINIO}/categoria/${idCategoriaSeleccionada}`
        );
        nombreCategorias = responseCategoria.data.categoria || "";
      } catch (error) {
        console.error("Error al obtener el nombre de la categoría", error);
      }
    }

    /* =========================
      IMÁGENES
      ========================= */
    let logoUrl =
      asociacionesData.imagen && asociacionesData.imagen !== "null"
        ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/ASOCIACIONES/${asociacionesData.imagen}`
        : "/img/logo-mundo-piloto.png";

    const getBase64Image = async (url) => {
      const res = await fetch(url);
      const blob = await res.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    };

    let colorBase64 = null;
    try {
      const responseCategoria = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/categoria/${idCategoriaSeleccionada}`
      );
      const colorFondo = responseCategoria.data.color_fondo;

      if (colorFondo) {
        const urlColor = `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/CATEGORIA/${colorFondo}`;
        colorBase64 = await getBase64Image(urlColor);
      }
    } catch (error) {
      console.error("Error al obtener color de fondo:", error);
    }

    const logoBase64 = await getBase64Image(logoUrl) || "/img/logo-mundo-piloto.png";

    /* =========================
      HEADER (IGUAL QUE ANTES)
      ========================= */
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFillColor(220, 220, 220);
    doc.rect(10, 10, pageWidth - 20, 30, "F");

    doc.addImage(logoBase64, "PNG", 15, 13, 35, 24);

    if (colorBase64) {
      doc.addImage(colorBase64, "JPEG", pageWidth - 40, 12, 26, 26);
    }

    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text(nombreAsociacion.toUpperCase(), pageWidth / 2, 20, {
      align: "center",
    });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text(titulo.toUpperCase(), pageWidth / 2, 28, { align: "center" });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text(nombreCategorias.toUpperCase(), pageWidth / 2, 35, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text(`Fecha: ${fecha}`, pageWidth / 20, 46);

    let startY = 50;
    const ordenSalida = categoriasSeleccionadas
    if (ordenSalida && ordenSalida.length > 0) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text((`${`Orden de salida`}`).toUpperCase(), pageWidth / 2, 54, { align: "center" });

      const textoCategorias = ordenSalida
        .map((c, i) => `${i + 1}°) ${c.categoria}`)
        .join("   ");

      const textoDividido = doc.splitTextToSize(
        textoCategorias,
        pageWidth - 20
      );

      let y = 62;
      textoDividido.forEach((linea) => {
        doc.setFont("helvetica", "normal");
        doc.text(linea, pageWidth / 2, y, { align: "center" });
        y += 6;
      });

      startY = y + 6;
    }

    /* =========================
      CONFIG TABLAS
      ========================= */
    const usarColumnasCompletas = gruposValidos.length === 1;
    const columnasPDF = usarColumnasCompletas
      ? (mostrarDatosAdicionales ? columns : columnsG)
      : columnsM;
    const headers = columnasPDF.map((c) => c.title);
    const indiceColumnaPiloto = columnasPDF.findIndex((c) => c.dataIndex === "piloto");
    const indiceColumnaInvitado = columnasPDF.findIndex((c) => c.dataIndex === "pilotoInvitado" || c.key === "pilotoInvitado");

    const marginX = 10;
    const gap = 5;
    const anchoDisponible =
      pageWidth - marginX * 2 - gap * (gruposValidos.length - 1);
    const anchoTabla = anchoDisponible / gruposValidos.length;
    const startYGrupos = startY;
    const paginaInicioGrupos = doc.internal.getNumberOfPages();

    /* =========================
      TABLAS
      ========================= */
    gruposValidos.forEach((grupo, index) => {
      const startX = marginX + index * (anchoTabla + gap);

      const filasGrupo = resultados
      .filter((r) => grupo.pilotosSeleccionados.includes(r.id_piloto))
      .sort((a, b) => a.orden - b.orden)
      .map((r) =>
        columnasPDF.map((col) => {
          if (col.dataIndex === "orden") return r.orden ?? "-";

          if (col.dataIndex === "numero_piloto") {
            return r.numero_piloto ?? "-";
          }

          if (col.dataIndex === "piloto") {
            return r.piloto
              ? `${r.piloto.apellido}, ${r.piloto.nombre}`
              : "-";
          }

          if (col.dataIndex === "pilotoInvitado" || col.key === "pilotoInvitado") {
            return r.pilotoInvitado
              ? `${r.pilotoInvitado.apellido}, ${r.pilotoInvitado.nombre}`
              : "Sin invitado";
          }

          if (col.key === "dni") {
            return r.piloto?.dni ?? "-";
          }

          if (col.key === "numero_telefono") {
            return r.piloto?.numero_telefono ?? "-";
          }

          if (col.key === "fecha_nacimiento") {
            return r.piloto?.fecha_nacimiento
              ? moment(r.piloto.fecha_nacimiento).format("DD/MM/YYYY")
              : "-";
          }

          return "-";
        })
      );

      doc.setPage(paginaInicioGrupos);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text(
        grupo.nombre || `Grupo ${index + 1}`,
        startX + anchoTabla / 2,
        startYGrupos + 1,
        { align: "center" }
      );

      doc.autoTable({
        head: [headers],
        body: filasGrupo,
        startY: startYGrupos + 2,
        tableWidth: anchoTabla,
        margin: { left: startX },
        styles: {
          fontSize: usarColumnasCompletas ? 9 : 9,
          cellPadding: 1,
        },
        headStyles: {
          fillColor: [34, 52, 99],
          textColor: 255,
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        didParseCell: (data) => {
          if (
            data.section === "body" &&
            (
              data.column.index === indiceColumnaPiloto ||
              (data.column.index === indiceColumnaInvitado && data.cell.raw === "Sin invitado")
            )
          ) {
            data.cell.styles.fontSize = 10.5;
          }
        },
      });
    });

    doc.save(`Armado_Grupos_${fecha.replaceAll("/", "-")}.pdf`);
  };

  const esUnSoloGrupo = grupos.length === 1;
  const handleAgregarGrupo = () => {
    if (grupos.length >= 3) {
      manejarAlertas("error", "Solo se puede agregar hasta 3 grupos.");
      return
    };
    setGrupos((prev) => [
      ...prev,
      {
        id: Date.now(),
        nombre: "",
        pilotosSeleccionados: [],
      },
    ]);
  }

  const elScroll = { x: 0 };
  let columns = [
    {
      title: "POS.",
      dataIndex: "orden",  // 👈 indicamos que la columna usa el campo orden
      key: "orden",
      align: "left",
      width: "50px",
      sorter: (a, b) => a.orden - b.orden,
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.orden}  {/* 👈 siempre usa el orden global */}
        </div>
      ),
    },
    {
      title: "NRO",
      key: "numero_piloto",
      dataIndex: "numero_piloto",
      align: "left",
      width: "50px",
      sorter: (a, b) => a.numero_piloto - b.numero_piloto,
      render: (valor, fila) => {
        const nro = valor;
        if (typeof nro === "string" || typeof nro === "number") {
          return <div style={{ fontSize: "12px", padding: "2px 4px" }}>{nro}</div>;
        }
        return <div style={{ fontSize: "12px", padding: "2px 4px" }}>-</div>;
      }
    },
    {
      title: "PILOTO",
      key: "piloto",
      dataIndex: "piloto",
      align: "left",
      width: "300px",
      sorter: (a, b) => {
        const nombreA = `${a.piloto?.apellido || ""} ${a.piloto?.nombre || ""}`.trim();
        const nombreB = `${b.piloto?.apellido || ""} ${b.piloto?.nombre || ""}`.trim();
        return nombreA.localeCompare(nombreB);
      },
      render: (piloto) => {
        if (!piloto) return "-";
        return (
          <div style={{ fontSize: "14px", padding: "2px 4px" }}>
            {piloto.apellido}, {piloto.nombre}
          </div>
        );
      }
    },
    {
      title: "DNI",
      key: "dni",
      align: "left",
      width: "100px",
      sorter: (a, b) => a.piloto?.dni - b.piloto?.dni,
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.piloto?.dni || "-"}
        </div>
      ),
    },
    {
      title: "TELÉFONO",
      key: "numero_telefono",
      align: "left",
      width: "100px",
      sorter: (a, b) => a.piloto?.numero_telefono - b.piloto?.numero_telefono,
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.piloto?.numero_telefono || "-"} 
        </div>
      ),
    },
    {
      title: "NACIMIENTO",
      key: "fecha_nacimiento",
      align: "left",
      width: "100px",
      sorter: (a, b) => a.piloto?.fecha_nacimiento - b.piloto?.fecha_nacimiento,
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.piloto?.fecha_nacimiento ? moment(`${record.piloto?.fecha_nacimiento}`, "YYYY-MM-DD").format("DD/MM/YYYY") : "-"} 
        </div>
      ),
    },
    // {
    //   title: "PUNTOS TOTALES",
    //   key: "puntos",
    //   dataIndex: "puntos",
    //   align: "center",
    //   sorter: (a, b) => {
    //     return (a.puntos || 0) - (b.puntos || 0);
    //   },
    //   render: (valor, record) => {
    //     return (
    //       <div style={{ fontSize: "12px", padding: "2px 4px" }}>
    //         {valor || 0}
    //       </div>
    //     );
    //   }
    // },
  ];
  if (invitados.length > 0) {
    columns.splice(3, 0, {
      title: "INVITADO",
      key: "pilotoInvitado", 
      dataIndex: "pilotoInvitado",
      align: "left",
      width: "300px",
      sorter: (a, b) => {
        const nombreA = `${a.pilotoInvitado?.apellido || ""} ${a.pilotoInvitado?.nombre || ""}`.trim();
        const nombreB = `${b.pilotoInvitado?.apellido || ""} ${b.pilotoInvitado?.nombre || ""}`.trim();
        return nombreA.localeCompare(nombreB);
      },
      render: (piloto) => {
        if (!piloto) return "Sin invitado";
        return (
          <div style={{ fontSize: "14px", padding: "2px 4px" }}>
            {piloto.apellido}, {piloto.nombre}
          </div>
        );
      }
    })
  }
  const columnsG = [
    {
      title: "POS.",
      dataIndex: "orden",  // 👈 indicamos que la columna usa el campo orden
      key: "orden",
      align: "left",
      width: "50px",
      sorter: (a, b) => a.orden - b.orden,
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.orden}  {/* 👈 siempre usa el orden global */}
        </div>
      ),
    },
    {
      title: "NRO",
      key: "numero_piloto",
      dataIndex: "numero_piloto",
      align: "left",
      width: "50px",
      sorter: (a, b) => a.numero_piloto - b.numero_piloto,
      render: (valor, fila) => {
        const nro = valor;
        if (typeof nro === "string" || typeof nro === "number") {
          return <div style={{ fontSize: "12px", padding: "2px 4px" }}>{nro}</div>;
        }
        return <div style={{ fontSize: "12px", padding: "2px 4px" }}>-</div>;
      }
    },
    {
      title: "PILOTO",
      key: "piloto",
      dataIndex: "piloto",
      align: "left",
      width: "300px",
      sorter: (a, b) => {
        const nombreA = `${a.piloto?.apellido || ""} ${a.piloto?.nombre || ""}`.trim();
        const nombreB = `${b.piloto?.apellido || ""} ${b.piloto?.nombre || ""}`.trim();
        return nombreA.localeCompare(nombreB);
      },
      render: (piloto) => {
        if (!piloto) return "-";
        return (
          <div style={{ fontSize: "14px", padding: "2px 4px" }}>
            {piloto.apellido}, {piloto.nombre}
          </div>
        );
      }
    },
  ]

  const columnsM = [
    {
      title: "POS.",
      dataIndex: "orden",
      key: "orden",
      align: "left",
      width: "50px",
      sorter: (a, b) => a.orden - b.orden,
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.orden}
        </div>
      ),
    },
    {
      title: "NRO",
      key: "numero_piloto",
      dataIndex: "numero_piloto",
      align: "left",
      width: "50px",
      sorter: (a, b) => a.numero_piloto - b.numero_piloto,
      render: (valor) => {
        const nro = valor;
        if (typeof nro === "string" || typeof nro === "number") {
          return <div style={{ fontSize: "12px", padding: "2px 4px" }}>{nro}</div>;
        }
        return <div style={{ fontSize: "12px", padding: "2px 4px" }}>-</div>;
      }
    },
    {
      title: "PILOTO",
      key: "piloto",
      dataIndex: "piloto",
      align: "left",
      width: "50px",
      sorter: (a, b) => {
        const nombreA = `${a.piloto?.apellido || ""} ${a.piloto?.nombre || ""}`.trim();
        const nombreB = `${b.piloto?.apellido || ""} ${b.piloto?.nombre || ""}`.trim();
        return nombreA.localeCompare(nombreB);
      },
      render: (piloto) => {
        if (!piloto) return "-";
        return (
          <div style={{ fontSize: "14px", padding: "2px 4px" }}>
            {piloto.apellido}, {piloto.nombre}
          </div>
        );
      }
    },
  ];

  if (invitados.length > 0) {
    columnsM.splice(3, 0, {
      title: "INVITADO",
      key: "pilotoInvitado",
      dataIndex: "pilotoInvitado",
      align: "left",
      width: "50px",
      sorter: (a, b) => {
        const nombreA = `${a.pilotoInvitado?.apellido || ""} ${a.pilotoInvitado?.nombre || ""}`.trim();
        const nombreB = `${b.pilotoInvitado?.apellido || ""} ${b.pilotoInvitado?.nombre || ""}`.trim();
        return nombreA.localeCompare(nombreB);
      },
      render: (piloto) => {
        if (!piloto) return "Sin invitado";
        return (
          <div style={{ fontSize: "14px", padding: "2px 4px" }}>
            {piloto.apellido}, {piloto.nombre}
          </div>
        );
      }
    });
  }

  const columnsTotal = [
    {
      title: "ORDEN",
      key: "orden",
      align: "left",
      width: "50px",
      render: (_, __, index) => {
        // current page y pageSize los obtenés desde la paginación de la tabla
        const currentPage = pagination?.current || 1;
        const pageSize = pagination?.pageSize || 30;

        return (
          <div style={{ fontSize: "12px", padding: "2px 4px" }}>
            {index + 1 + (currentPage - 1) * pageSize}
          </div>
        );
      },
    },
    {
      title: "DNI",
      key: "dni",
      align: "left",
      width: "50px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.dni || "-"}
        </div>
      ),
    },
    {
      title: "PILOTO",
      key: "piloto",
      dataIndex: "piloto",
      align: "left",
      width: "100px",
      sorter: (a, b) => {
        const nombreA = `${a.apellido || ""} ${a.nombre || ""}`.trim();
        const nombreB = `${b.apellido || ""} ${b.nombre || ""}`.trim();
        return nombreA.localeCompare(nombreB);
      },
      render: (_, record) => (
        <div style={{ fontSize: "14px", padding: "2px 4px" }} className="notranslate" translate="no">
          {record.apellido}, {record.nombre}
        </div>
      )
    },
    {
      title: "TELÉFONO",
      key: "numero_telefono",
      align: "left",
      width: "50px",
      sorter: (a, b) => a.numero_telefono - b.numero_telefono,
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.numero_telefono || "-"}
        </div>
      ),
    },
    {
      title: "NACIMIENTO",
      key: "fecha_nacimiento",
      align: "left",
      width: "50px",
      sorter: (a, b) => a.fecha_nacimiento - b.fecha_nacimiento,
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.fecha_nacimiento ? moment(`${record.fecha_nacimiento}`, "YYYY-MM-DD").format("DD/MM/YYYY") : "-"} 
        </div>
      ),
    },
    {
      title: "LOCALIDAD",
      key: "localidad",
      align: "left",
      width: "50px",
      sorter: (a, b) => a.localidad - b.localidad,
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record.localidad || "-"}
        </div>
      ),
    },
    {
      title: "CATEGORÍAS",
      key: "categorias",
      align: "left",
      width: "50px",
      render: (_, record) => {
        if (!record?.inscripciones || record.inscripciones.length === 0) {
          return (
            <span translate="no" className="notranslate">
              No tiene categorías vinculadas
            </span>
          );
        }

        const categoriasUnicas = Array.from(
          new Map(record.inscripciones.map(i => [i.id_categoria, i.categoria])).values()
        );

        return (
          <span translate="no" className="notranslate">
            {categoriasUnicas.join(", ")}
          </span>
        );
      },
    }
  ]

  const columnsCubiertas = [
    {
      title: "POS.",
      dataIndex: "orden",
      key: "orden",
      width: 60,
      render: (v) => <div style={{ fontSize: 12 }}>{v ?? "-"}</div>
    },
    {
      title: "NRO",
      dataIndex: "numero_piloto",
      key: "numero_piloto",
      align: "left",
      width: "60px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.numero_piloto ?? "-"}
        </div>
      ),
    },
    {
      title: "PILOTO",
      dataIndex: "piloto",
      key: "piloto",
      align: "left",
      width: "260px",
      render: (_, record) => (
        <div style={{ fontSize: "14px", padding: "2px 4px" }}>
          {record?.piloto ? `${record.piloto.apellido}, ${record.piloto.nombre}` : "-"}
        </div>
      ),
    },
    {
      title: "DEL.IZQ",
      key: "FL",
      align: "left",
      width: "90px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.cubiertas?.FL || "-"}
        </div>
      ),
    },
    {
      title: "DEL.DER",
      key: "FR",
      align: "left",
      width: "90px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.cubiertas?.FR || "-"}
        </div>
      ),
    },
    {
      title: "TRAS.IZQ",
      key: "RL",
      align: "left",
      width: "90px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.cubiertas?.RL || "-"}
        </div>
      ),
    },
    {
      title: "TRAS.DER",
      key: "RR",
      align: "left",
      width: "90px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.cubiertas?.RR || "-"}
        </div>
      ),
    },
  ];

  const columnsHistorialCubiertas = [
    {
      title: "FECHA",
      key: "fecha",
      align: "left",
      width: "120px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.fecha ? moment(record.fecha).format("DD/MM/YYYY") : "-"}
        </div>
      ),
    },
    {
      title: "DEL.IZQ",
      key: "FL",
      align: "left",
      width: "90px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.FL || "-"}
        </div>
      ),
    },
    {
      title: "DEL.DER",
      key: "FR",
      align: "left",
      width: "90px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.FR || "-"}
        </div>
      ),
    },
    {
      title: "TRAS.IZQ",
      key: "RL",
      align: "left",
      width: "90px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.RL || "-"}
        </div>
      ),
    },
    {
      title: "TRAS.DER",
      key: "RR",
      align: "left",
      width: "90px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.RR || "-"}
        </div>
      ),
    },
  ];

  const columnsPrecintos = [
    {
      title: "POS.",
      dataIndex: "pos",
      key: "pos",
      width: 60,
      render: (v) => <div style={{ fontSize: 12 }}>{v ?? "-"}</div>
    },
    {
      title: "NRO",
      dataIndex: "numero_piloto",
      key: "numero_piloto",
      align: "left",
      width: "60px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.numero_piloto ?? "-"}
        </div>
      ),
    },
    {
      title: "PILOTO",
      dataIndex: "piloto",
      key: "piloto",
      align: "left",
      width: "260px",
      render: (_, record) => (
        <div style={{ fontSize: "14px", padding: "2px 4px" }}>
          {record?.piloto ? `${record.piloto.apellido}, ${record.piloto.nombre}` : "-"}
        </div>
      ),
    },
    {
      title: "MOTOR",
      key: "motor",
      align: "left",
      width: "150px",
      render: (_, record) => renderCampoConHistorial(record?.motor),
    },
  ];

  const columnsHistorialPrecintos = [
    {
      title: "FECHA",
      key: "fecha",
      align: "left",
      width: "120px",
      render: (_, record) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {record?.fecha ? moment(record.fecha).format("DD/MM/YYYY") : "-"}
        </div>
      ),
    },
    {
      title: "MOTOR",
      key: "motor",
      align: "left",
      width: "150px",
      render: (_, record) => renderCampoConHistorial(record?.motor),
    },
  ];

  const columnsLicencias = [
    {
      title: "POS.",
      dataIndex: "orden",
      key: "orden",
      align: "left",
      width: 60,
      sorter: (a, b) => a.orden - b.orden,
      render: (v) => <div style={{ fontSize: 12, padding: "2px 4px" }}>{v ?? "-"}</div>,
    },
    {
      title: "NRO",
      dataIndex: "numero_piloto",
      key: "numero_piloto",
      align: "left",
      width: 60,
      sorter: (a, b) => (a.numero_piloto ?? 0) - (b.numero_piloto ?? 0),
      render: (v) => <div style={{ fontSize: 12, padding: "2px 4px" }}>{v ?? "-"}</div>,
    },
    {
      title: "PILOTO",
      dataIndex: "piloto",
      key: "piloto",
      align: "left",
      width: 260,
      sorter: (a, b) => {
        const nA = `${a.piloto?.apellido || ""} ${a.piloto?.nombre || ""}`.trim();
        const nB = `${b.piloto?.apellido || ""} ${b.piloto?.nombre || ""}`.trim();
        return nA.localeCompare(nB);
      },
      render: (piloto) =>
        piloto ? (
          <div style={{ fontSize: 14, padding: "2px 4px" }}>
            {piloto.apellido}, {piloto.nombre}
          </div>
        ) : "-",
    },
    {
      title: "DNI",
      key: "dni",
      align: "left",
      width: 100,
      sorter: (a, b) => (a.piloto?.dni ?? 0) - (b.piloto?.dni ?? 0),
      render: (_, record) => (
        <div style={{ fontSize: 12, padding: "2px 4px" }}>
          {record.piloto?.dni || "-"}
        </div>
      ),
    },
    {
      title: "LICENCIA",
      dataIndex: "tiene_licencia",
      key: "tiene_licencia",
      align: "center",
      width: 90,
      sorter: (a, b) => (a.tiene_licencia === b.tiene_licencia ? 0 : a.tiene_licencia ? -1 : 1),
      render: (val) => (
        <div
          style={{
            fontSize: 14,
            padding: "2px 4px",
            color: val === true ? "#389e0d" : "#cf1322",
            fontWeight: "bold",
          }}
        >
          {val === true ? "Sí" : "No"}
        </div>
      ),
    },
    {
      title: () => (
        <div style={{ textAlign: "center" }}>
          <span></span>
        </div>
      ),
      key: "opciones",
      align: "center",
      width: 80,
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {record.tiene_licencia === true ? (
            <Tooltip title="Ver licencia" placement="top">
              <FaEye
                className="iconos-tablas"
                style={{ color: "rgb(34, 52, 99)", cursor: "pointer" }}
                onClick={() => handleAbrirLicencia(record)}
              />
            </Tooltip>
          ) : null}
        </div>
      ),
    },
  ];

  // console.log("grupos", grupos)
  return (
    <>
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Grupos</h1>
      </section>

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <div
          className="contendor-card-carreras"
          style={{
            width: "auto",
            width: "1000px",
            padding: "10px 20px",
            border: "1px solid #bbbbbb",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <h1 className="titulos-secundarios"  style={{ fontSize: 18 }}>Armar grupos</h1>
            <Col xs={24} sm={12} md={8} style={{ width: "100%", alignSelf: "center" }}>
              <Form.Item style={{ width: "100%", alignSelf: "center" }}>
                <Select
                  placeholder="Seleccioná un tipo de armado"
                  value={modoVista}
                  onChange={onChangeModoVista}
                  style={{ width: "100%" }}
                  options={[
                    { value: MODOS.ARMAR_GRUPO, label: "Armar grupo" },
                    { value: MODOS.MOSTRAR_TODOS, label: "Mostrar todos los pilotos" },
                    { value: MODOS.ARMAR_GRUPO_CUBIERTAS, label: "Armar grupo de cubiertas" },
                    { value: MODOS.MOSTRAR_CUBIERTA_PILOTO, label: "Mostrar cubierta del piloto" },
                    { value: MODOS.ARMAR_GRUPO_LICENCIAS, label: "Armar grupo de licencias" },
                    { value: MODOS.ARMAR_GRUPO_PRECINTOS, label: "Armar grupo de precintos" },
                    { value: MODOS.MOSTRAR_PRECINTO_PILOTO, label: "Mostrar precintos del piloto" },
                  ]}
                />
              </Form.Item>
            </Col>
          </div>
          <Row 
            align="middle" 
            justify={"center"}
            style={{ marginTop: 0 }}
          >
            {mostrarTodos === false ? (
              <>
                {mostrarGrupo === true && (
                  <>
                    <Col
                      xs={24} sm={12} md={8}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        padding: "0 10px"
                      }}
                    >
                      <Form.Item
                        style={{ width:"100%" }}>
                          <SelectCampeonatosResultado
                            idCampo={"id_campeonato"}
                            nombreCampo={"Campeonato"}
                            elPlaceholder="Seleccione un campeonato"
                            arrayOpciones={campeonato.length > 0 ? campeonato : []} // Debe ser los campeonatos de la categoría activa
                            textoOpciones="label"
                            onChange={(e) => handleCampeonatoChange(e, sesion.id_asociacion)}
                            elValue={campeonatoSeleccionado} // Valor seleccionado por defecto
                          />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24} sm={12} md={8}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        padding: "0 10px"
                      }}
                    >
                      <Form.Item
                      style={{ width: "100%" }}>
                        <SelectCustomCarreras
                          idCampo={"id_carrera"}
                          nombreCampo={"Carreras"}
                          elPlaceholder={"Seleccioná una carrera"}
                          arrayOpciones={carrerasFiltradas.length > 0 ? carrerasFiltradas : []}
                          required={false}
                          onChange={handleCarreraChange}
                          elValue={idCarreraSeleccionada}
                        />
                      </Form.Item>
                    </Col>
                    {idCarreraSeleccionada ? (
                      <Col
                        xs={24} sm={12} md={8}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          padding: "0 10px"
                        }}
                      >
                        <Form.Item style={{ height: "100%" }}>
                            <SelectCustom
                              idCampo={"id_categoria"}
                              nombreCampo={"Categorias"}
                              elPlaceholder={"Seleccioná una categoria"}
                              arrayOpciones={categorias.length > 0 ? categorias : []}
                              required={true}
                              onChange={handleCategoriaChange}
                              textoOpciones={"categoria"}
                              elValue={idCategoriaSeleccionada}
                            />
                        </Form.Item>
                      </Col>
                    ) : null}
                    {idCategoriaSeleccionada ? (
                      <Row gutter={16} style={{ marginTop: 0, alignItems: "center", width: "100%", justifyContent: "center" }}>
                        <Col xs={24} sm={12} align="middle">
                          <Form.Item
                            style={{
                              width: "100%",
                            }}
                          >
                            <Button
                              style={{
                                width: "100%",
                                backgroundColor: "#223463",
                                color: "#fff",
                                fontSize: 16,
                              }}
                              onClick={() => setModalCategoriasVisible(true)}
                            >
                              Armar grupo de salida
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                    ) : null}
                    {modalCategoriasVisible && (
                      <Modal
                        open={modalCategoriasVisible}
                        title="Armado de grupo - Orden de salida"
                        onCancel={() => setModalCategoriasVisible(false)}
                        footer={
                          <Button
                            style={{
                              backgroundColor: "#BA1721",
                              color: "#FFF",
                              fontSize: 18,
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              setModalCategoriasVisible(false);
                            }}
                          >
                            Aceptar
                          </Button>
                        }
                        width={600}
                      >
                        <Row gutter={16} style={{ marginTop: 15, marginBottom: 15, alignItems: "end" }}>
                          <Col xs={24} sm={24} align="middle" >
                              <div style={{ width: "100%" }}>
                                <h1 className="titulos-secundarios ">
                                  Orden de salida
                                </h1>
                              </div>
                          </Col>
                        </Row>
                        <Row gutter={16} style={{ marginBottom: 15, alignItems: "end" }}>
                          <Col xs={24} sm={24} align="middle">
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "center" }}>
                            {categorias.map((c) => {
                              return (
                                <label
                                  key={c.id}
                                  style={{
                                    border: `1px solid "#d5d5d5"`,
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    gap: "6px",
                                    transition: "all 0.2s ease-in-out",
                                  }}
                                >
                                  <Checkbox
                                    checked={categoriasSeleccionadas.some((cat) => cat.id === c.id)}
                                    onChange={(e) => onChangeCategoria(e, c)}
                                  />
                                  {c.categoria}
                                </label>
                              );
                            })}
                          </div>
                        </Col>
                        </Row>
                        <div style={{ display: "flex", width: "100%", flexDirection: "row", marginTop: 10, textAlign: "center", flexWrap: "wrap" }}>
                          {categoriasSeleccionadas.map((c, index) => (
                            <div key={c.id_categoria} style={{ display: "flex", paddingRight: 10 }}>
                              {`${index + 1}°) ${c.categoria} `}
                            </div>
                          ))}
                        </div>
                      </Modal>
                    )}
                  </>
                )}
                {/* <Col xs={24} sm={12} md={8} 
                  style={{ 
                    display: "flex",
                    justifyContent: "center",
                    alignSelf: "center"
                    // marginTop: 22 
                  }}
                >
                  <Button
                    onClick={() => mostrarGrupo ? handleGrupo(false) : handleGrupo(true)}
                    style={{ width: "95%", fontSize: 18, color: "#fff", backgroundColor: "#223463" }}
                    
                  >
                    {mostrarGrupo ? "Cancelar" : "Armar Grupos"}
                  </Button>
                </Col> */}
              </>
            ) : ""}
            {mostrarGrupo === false ? (
              <>
                {mostrarTodos === true && (
                  <>
                    <Col
                        xs={24} sm={12} md={8}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          padding: "0 10px"
                        }}
                      >
                        <Form.Item
                          style={{ width:"100%" }}>
                            <SelectCampeonatosResultado
                              idCampo={"id_campeonato"}
                              nombreCampo={"Campeonato"}
                              elPlaceholder="Seleccione un campeonato"
                              arrayOpciones={campeonato.length > 0 ? campeonato : []} // Debe ser los campeonatos de la categoría activa
                              textoOpciones="label"
                              onChange={(e) => handleCampeonatoChange(e, sesion.id_asociacion)}
                              elValue={campeonatoSeleccionado} // Valor seleccionado por defecto
                            />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24} sm={12} md={8}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          padding: "0 10px"
                        }}
                      >
                        <Form.Item
                        style={{ width: "100%" }}>
                          <SelectCustomCarreras
                            idCampo={"id_carrera"}
                            nombreCampo={"Carreras"}
                            elPlaceholder={"Seleccioná una carrera"}
                            arrayOpciones={carrerasFiltradas.length > 0 ? carrerasFiltradas : []}
                            required={false}
                            onChange={handleCarreraChangeTotal}
                            elValue={idCarreraSeleccionada}
                          />
                        </Form.Item>
                    </Col>
                  </>
                )}
                {/* <Col xs={24} sm={12} md={8} 
                  style={{ 
                    display: "flex",
                    justifyContent: "center",
                    alignSelf: "center"
                    // marginTop: 22 
                  }}
                >
                  <Button
                    onClick={() => mostrarTodos ? handleTodos(false) : handleTodos(true)}
                    style={{ width: "95%", fontSize: 18, color: "#fff", backgroundColor: "#BA1721" }}
                  >
                    {mostrarTodos ? "Cancelar" : "Mostrar todos los pilotos"}
                  </Button>
                </Col> */}
              </>
            ) : ""}
            {modoVista === MODOS.ARMAR_GRUPO_CUBIERTAS && (
              <>
                <Col xs={24} sm={8} style={{ padding: "0 10px" }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCampeonatosResultado
                      idCampo={"id_campeonato"}
                      nombreCampo={"Campeonato"}
                      elPlaceholder="Seleccione un campeonato"
                      arrayOpciones={campeonato.length > 0 ? campeonato : []}
                      textoOpciones="label"
                      onChange={(e) => handleCampeonatoChange(e, sesion.id_asociacion)}
                      elValue={campeonatoSeleccionado}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} style={{ padding: "0 10px" }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCustomCarreras
                      idCampo={"id_carrera"}
                      nombreCampo={"Carreras"}
                      elPlaceholder={"Seleccioná una carrera"}
                      arrayOpciones={carrerasFiltradas.length > 0 ? carrerasFiltradas : []}
                      required={false}
                      onChange={handleCarreraChange}
                      elValue={idCarreraSeleccionada}
                    />
                  </Form.Item>
                </Col>
                {idCarreraSeleccionada && (
                  <Col xs={24} sm={8} style={{ padding: "0 10px" }}>
                    <Form.Item style={{ width:"100%" }}>
                      <SelectCustom
                        idCampo={"id_categoria"}
                        nombreCampo={"Categorias"}
                        elPlaceholder={"Seleccioná una categoria"}
                        arrayOpciones={categorias.length > 0 ? categorias : []}
                        required={true}
                        onChange={handleCategoriaChange}
                        textoOpciones={"categoria"}
                        elValue={idCategoriaSeleccionada}
                      />
                    </Form.Item>
                  </Col>
                )}
               
              </>
            )}
            {modoVista === MODOS.ARMAR_GRUPO_LICENCIAS && (
              <>
                <Col xs={24} sm={8} style={{ padding: "0 10px" }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCampeonatosResultado
                      idCampo={"id_campeonato"}
                      nombreCampo={"Campeonato"}
                      elPlaceholder="Seleccione un campeonato"
                      arrayOpciones={campeonato.length > 0 ? campeonato : []}
                      textoOpciones="label"
                      onChange={(e) => handleCampeonatoChange(e, sesion.id_asociacion)}
                      elValue={campeonatoSeleccionado}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} style={{ padding: "0 10px" }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCustomCarreras
                      idCampo={"id_carrera"}
                      nombreCampo={"Carreras"}
                      elPlaceholder={"Seleccioná una carrera"}
                      arrayOpciones={carrerasFiltradas.length > 0 ? carrerasFiltradas : []}
                      required={false}
                      onChange={handleCarreraChange}
                      elValue={idCarreraSeleccionada}
                    />
                  </Form.Item>
                </Col>
                {idCarreraSeleccionada && (
                  <Col xs={24} sm={8} style={{ padding: "0 10px" }}>
                    <Form.Item style={{ width:"100%" }}>
                      <SelectCustom
                        idCampo={"id_categoria"}
                        nombreCampo={"Categorias"}
                        elPlaceholder={"Seleccioná una categoria"}
                        arrayOpciones={categorias.length > 0 ? categorias : []}
                        required={true}
                        onChange={handleCategoriaChange}
                        textoOpciones={"categoria"}
                        elValue={idCategoriaSeleccionada}
                      />
                    </Form.Item>
                  </Col>
                )}
              </>
            )}
            {modoVista === MODOS.MOSTRAR_CUBIERTA_PILOTO && (
              <>
                <Col xs={24} sm={8} style={{ paddingRight: 10 }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCampeonatosResultado
                      idCampo={"id_campeonato"}
                      nombreCampo={"Campeonato"}
                      elPlaceholder="Seleccione un campeonato"
                      arrayOpciones={campeonato.length > 0 ? campeonato : []}
                      textoOpciones="label"
                      onChange={(e) => handleCampeonatoChange(e, sesion.id_asociacion)}
                      elValue={campeonatoSeleccionado}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} style={{ paddingRight: 10 }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCustom
                      idCampo={"id_categoria"}
                      nombreCampo={"Categorias"}
                      elPlaceholder={"Seleccioná una categoria"}
                      arrayOpciones={categoriasPiloto?.length ? categoriasPiloto : []}
                      required={true}
                      onChange={handleCategoriaChangeSoloCubiertas}
                      textoOpciones={"categoria"}
                      elValue={idCategoriaSeleccionada}
                    />
                  </Form.Item>
                </Col>
                {idCategoriaSeleccionada && (
                  <Col xs={24} sm={8} style={{ paddingRight: 10 }}>
                    <Form.Item style={{ width: "100%" }}>
                      <SelectCustom
                        idCampo={"id_piloto"}
                        nombreCampo={"Pilotos"}
                        elPlaceholder={"Seleccioná un piloto"}
                        arrayOpciones={pilotosSelect?.length > 0 ? pilotosSelect : []}
                        required={true}
                        onChange={handlePilotoChange}
                        textoOpciones={"label"}  // 👈 importante
                        elValue={pilotoSeleccionado}
                      />
                    </Form.Item>
                  </Col>
                )}
              </>
            )}
            {modoVista === MODOS.ARMAR_GRUPO_PRECINTOS && (
              <>
                <Col xs={24} sm={8} style={{ padding: "0 10px" }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCampeonatosResultado
                      idCampo={"id_campeonato"}
                      nombreCampo={"Campeonato"}
                      elPlaceholder="Seleccione un campeonato"
                      arrayOpciones={campeonato.length > 0 ? campeonato : []}
                      textoOpciones="label"
                      onChange={(e) => handleCampeonatoChange(e, sesion.id_asociacion)}
                      elValue={campeonatoSeleccionado}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} style={{ padding: "0 10px" }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCustomCarreras
                      idCampo={"id_carrera"}
                      nombreCampo={"Carreras"}
                      elPlaceholder={"Seleccioná una carrera"}
                      arrayOpciones={carrerasFiltradas.length > 0 ? carrerasFiltradas : []}
                      required={false}
                      onChange={handleCarreraChange}
                      elValue={idCarreraSeleccionada}
                    />
                  </Form.Item>
                </Col>

                {idCarreraSeleccionada && (
                  <Col xs={24} sm={8} style={{ padding: "0 10px" }}>
                    <Form.Item style={{ width:"100%" }}>
                      <SelectCustom
                        idCampo={"id_categoria"}
                        nombreCampo={"Categorias"}
                        elPlaceholder={"Seleccioná una categoria"}
                        arrayOpciones={categorias.length > 0 ? categorias.filter((c) => c.cargaPrecintos) : []}
                        required={true}
                        onChange={handleCategoriaPrecintosChange}
                        textoOpciones={"categoria"}
                        elValue={idCategoriaPrecintosSeleccionada}
                      />
                    </Form.Item>
                  </Col>
                )}
              </>
            )}
            {modoVista === MODOS.MOSTRAR_PRECINTO_PILOTO && (
              <>
                <Col xs={24} sm={8} style={{ paddingRight: 10 }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCampeonatosResultado
                      idCampo={"id_campeonato"}
                      nombreCampo={"Campeonato"}
                      elPlaceholder="Seleccione un campeonato"
                      arrayOpciones={campeonato.length > 0 ? campeonato : []}
                      textoOpciones="label"
                      onChange={(e) => handleCampeonatoChange(e, sesion.id_asociacion)}
                      elValue={campeonatoSeleccionado}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} style={{ paddingRight: 10 }}>
                  <Form.Item style={{ width:"100%" }}>
                    <SelectCustom
                      idCampo={"id_categoria"}
                      nombreCampo={"Categorias"}
                      elPlaceholder={"Seleccioná una categoria"}
                      arrayOpciones={categoriasPiloto?.length ? categoriasPiloto.filter((c) => c.cargaPrecintos) : []}
                      required={true}
                      onChange={handleCategoriaPrecintosPilotoChange}
                      textoOpciones={"categoria"}
                      elValue={idCategoriaPrecintosSeleccionada}
                    />
                  </Form.Item>
                </Col>
                {idCategoriaPrecintosSeleccionada && (
                  <Col xs={24} sm={8} style={{ paddingRight: 10 }}>
                    <Form.Item style={{ width: "100%" }}>
                      <SelectCustom
                        idCampo={"id_piloto"}
                        nombreCampo={"Pilotos"}
                        elPlaceholder={"Seleccioná un piloto"}
                        arrayOpciones={pilotosSelectPrecintos?.length > 0 ? pilotosSelectPrecintos : []}
                        required={true}
                        onChange={handlePilotoPrecintosChange}
                        textoOpciones={"label"}
                        elValue={pilotoSeleccionadoPrecintos}
                      />
                    </Form.Item>
                  </Col>
                )}
              </>
            )}
          </Row>
        </div>

        {modoVista === MODOS.ARMAR_GRUPO_CUBIERTAS && idCategoriaSeleccionada && (
          <div
            className="contendor-card-carreras"
            style={{
              width: "1000px",
              padding: "20px",
              border: "1px solid #bbbbbb",
              borderRadius: "10px",
              marginTop: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <h1 className="titulos-secundarios">Armar grupo de cubiertas</h1>

              <BotonPrincipal
                onClick={() => handleFormCubiertas((t) => !t)}
                texto={mostrarFormCubiertas ? "Cancelar" : "Configurar grupo"}
              />
            </div>

            <hr />

            {mostrarFormCubiertas && (
              <Row gutter={16} style={{ marginTop: 15, alignItems: "end" }}>
                <Col xs={24} sm={8}>
                  <Form.Item style={{ width: "100%" }}>
                    <InputCustom
                      idCampo="nombre_grupo_cubiertas"
                      nombreCampo="Nombre de grupo"
                      tipo="text"
                      elValue={nombreGrupoCubiertas}
                      elPlaceholder="Ej: Grupo Cubiertas 1"
                      onChange={(e) => setNombreGrupoCubiertas(e.target.value)}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} align="middle">
                  <Form.Item style={{ width: "100%" }}>
                    <Checkbox
                      checked={asistenciaCubiertas}
                      onChange={(e) => setAsistenciaCubiertas(e.target.checked)}
                    >
                      Solo pilotos que asisten
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} align="middle">
                  <Form.Item style={{ width: "100%" }}>
                    <Checkbox
                      checked={seleccionarTodosCubiertas}
                      onChange={(e) => setSeleccionarTodosCubiertas(e.target.checked)}
                    >
                      Seleccionar todos los pilotos
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            )}

            {/* tabla */}
            <div style={{ marginTop: 15 }}>
              <TablaCompletaGrupos
                tituloPDF={"grupo_cubiertas"}
                elScroll={{ x: 0 }}
                columns={columnsCubiertas}
                filasPorPagina={30}
                fetchDatos={tablaCubiertas}
                rowKey={"id_piloto"}
                tituloBanner={nombreGrupoCubiertas || "Grupo de cubiertas"}
                idAsociacion={sesion.id_asociacion}
                idCategoria={idCategoriaSeleccionada}
                modoArmarGrupo={mostrarFormCubiertas} // si querés seleccionar pilotos
                todosPilotos={seleccionarTodosCubiertas}
                filtrarUltimaColumna={false}
                textoDescarga={"Descargar grupo cubiertas"}
                pagination={pagination}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        )}

        {modoVista === MODOS.ARMAR_GRUPO_PRECINTOS && idCategoriaPrecintosSeleccionada && (
          <div
            className="contendor-card-carreras"
            style={{
              width: "1000px",
              padding: "20px",
              border: "1px solid #bbbbbb",
              borderRadius: "10px",
              marginTop: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <h1 className="titulos-secundarios">Armar grupo de precintos</h1>

              <BotonPrincipal
                onClick={() => handleFormPrecintos((t) => !t)}
                texto={mostrarFormPrecintos ? "Cancelar" : "Configurar grupo"}
              />
            </div>

            <hr />

            {mostrarFormPrecintos && (
              <Row gutter={16} style={{ marginTop: 15, alignItems: "end" }}>
                <Col xs={24} sm={8}>
                  <Form.Item style={{ width: "100%" }}>
                    <InputCustom
                      idCampo="nombre_grupo_precintos"
                      nombreCampo="Nombre de grupo"
                      tipo="text"
                      elValue={nombreGrupoPrecintos}
                      elPlaceholder="Ej: Grupo Precintos 1"
                      onChange={(e) => setNombreGrupoPrecintos(e.target.value)}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} align="middle">
                  <Form.Item style={{ width: "100%" }}>
                    <Checkbox
                      checked={asistenciaPrecintos}
                      onChange={(e) => setAsistenciaPrecintos(e.target.checked)}
                    >
                      Solo pilotos que asisten
                    </Checkbox>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} align="middle">
                  <Form.Item style={{ width: "100%" }}>
                    <Checkbox
                      checked={seleccionarTodosPrecintos}
                      onChange={(e) => setSeleccionarTodosPrecintos(e.target.checked)}
                    >
                      Seleccionar todos los pilotos
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            )}

            {/* tabla */}
            <div style={{ marginTop: 15 }}>
              <TablaCompletaGrupos
                tituloPDF={"grupo_precintos"}
                elScroll={{ x: 0 }}
                columns={columnsPrecintos}
                filasPorPagina={30}
                fetchDatos={tablaPrecintos}
                rowKey={"id_piloto"}
                tituloBanner={nombreGrupoPrecintos || "Grupo de precintos"}
                idAsociacion={sesion.id_asociacion}
                idCategoria={idCategoriaPrecintosSeleccionada}
                modoArmarGrupo={mostrarFormPrecintos}
                todosPilotos={seleccionarTodosPrecintos}
                filtrarUltimaColumna={false}
                camposConHistorial={CAMPOS_PRECINTOS_CON_HISTORIAL}
                textoDescarga={"Descargar grupo precintos"}
                pagination={pagination}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        )}

        {modoVista === MODOS.ARMAR_GRUPO_LICENCIAS && idCategoriaSeleccionada && (
          <div
            className="contendor-card-carreras"
            style={{
              width: "1000px",
              padding: "20px",
              border: "1px solid #bbbbbb",
              borderRadius: "10px",
              marginTop: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <h1 className="titulos-secundarios">Armar grupo de licencias</h1>
              <BotonPrincipal
                onClick={() => {
                  setMostrarFormLicencias((t) => !t);
                  if (mostrarFormLicencias) {
                    setNombreGrupoLicencias("");
                    setAsistenciaLicencias(false);
                    setSeleccionarTodosLicencias(false);
                  }
                }}
                texto={mostrarFormLicencias ? "Cancelar" : "Configurar grupo"}
              />
            </div>

            <hr />

            {mostrarFormLicencias && (
              <Row gutter={16} style={{ marginTop: 15, alignItems: "end" }}>
                <Col xs={24} sm={8}>
                  <Form.Item style={{ width: "100%" }}>
                    <InputCustom
                      idCampo="nombre_grupo_licencias"
                      nombreCampo="Nombre de grupo"
                      tipo="text"
                      elValue={nombreGrupoLicencias}
                      elPlaceholder="Ej: Grupo Licencias 1"
                      onChange={(e) => setNombreGrupoLicencias(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8} align="middle">
                  <Form.Item style={{ width: "100%" }}>
                    <Checkbox
                      checked={asistenciaLicencias}
                      onChange={(e) => setAsistenciaLicencias(e.target.checked)}
                    >
                      Solo pilotos que asisten
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8} align="middle">
                  <Form.Item style={{ width: "100%" }}>
                    <Checkbox
                      checked={seleccionarTodosLicencias}
                      onChange={(e) => setSeleccionarTodosLicencias(e.target.checked)}
                    >
                      Seleccionar todos los pilotos
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            )}

            <div style={{ marginTop: 15 }}>
              <TablaCompletaGrupos
                tituloPDF={"grupo_licencias"}
                elScroll={{ x: 0 }}
                columns={columnsLicencias}
                filasPorPagina={30}
                fetchDatos={tablaLicencias}
                rowKey={"id_piloto"}
                tituloBanner={nombreGrupoLicencias?.trim() || "Grupo de licencias"}
                idAsociacion={sesion.id_asociacion}
                idCategoria={idCategoriaSeleccionada}
                modoArmarGrupo={mostrarFormLicencias}
                todosPilotos={seleccionarTodosLicencias}
                filtrarUltimaColumna={false}
                textoDescarga={"Descargar grupo licencias"}
                pagination={pagination}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        )}

        {modoVista === MODOS.MOSTRAR_CUBIERTA_PILOTO && pilotoSeleccionado &&(
          <div
            className="contendor-card-carreras"
            style={{
              width: "1000px",
              padding: "20px",
              border: "1px solid #bbbbbb",
              borderRadius: "10px",
              marginTop: 10,
            }}
          >
            <h1 className="titulos-secundarios">Mostrar cubiertas del piloto ({pilotoSeleccionadoNombre})</h1>
            <hr />

           {pilotoSeleccionado ? (
            <TablaCompletaGrupos
              tituloPDF={"historial_cubiertas_piloto"}
              elScroll={{ x: 0 }}
              columns={columnsHistorialCubiertas}
              filasPorPagina={30}
              fetchDatos={historialPiloto}
              rowKey={"id_carrera"}
              tituloBanner={"Historial de cubiertas"}
              filtrarUltimaColumna={false}
              textoDescarga={"Descargar historial"}
              pagination={pagination}
              onPaginationChange={handlePaginationChange}
              idAsociacion={sesion.id_asociacion}
              pilotoCubiertas={pilotoSeleccionadoNombre}
            />
          ) : (
            <div style={{ width: "100%", textAlign: "center", marginTop: 20 }}>
              <p>Seleccioná un piloto para ver su historial.</p>
            </div>
          )}
          </div>
        )}

        {modoVista === MODOS.MOSTRAR_PRECINTO_PILOTO && pilotoSeleccionadoPrecintos && (
          <div
            className="contendor-card-carreras"
            style={{
              width: "1000px",
              padding: "20px",
              border: "1px solid #bbbbbb",
              borderRadius: "10px",
              marginTop: 10,
            }}
          >
            <h1 className="titulos-secundarios">Mostrar precintos del piloto ({pilotoSeleccionadoPrecintosNombre})</h1>
            <hr />

           {pilotoSeleccionadoPrecintos ? (
            <TablaCompletaGrupos
              tituloPDF={"historial_precintos_piloto"}
              elScroll={{ x: 0 }}
              columns={columnsHistorialPrecintos}
              filasPorPagina={30}
              fetchDatos={historialPrecintosPiloto}
              rowKey={"id_carrera"}
              tituloBanner={"Historial de precintos"}
              filtrarUltimaColumna={false}
              camposConHistorial={CAMPOS_PRECINTOS_CON_HISTORIAL}
              textoDescarga={"Descargar historial"}
              pagination={pagination}
              onPaginationChange={handlePaginationChange}
              idAsociacion={sesion.id_asociacion}
              pilotoCubiertas={pilotoSeleccionadoPrecintosNombre}
            />
          ) : (
            <div style={{ width: "100%", textAlign: "center", marginTop: 20 }}>
              <p>Seleccioná un piloto para ver su historial.</p>
            </div>
          )}
          </div>
        )}

        {mostrarTodos && idCarreraSeleccionada && campeonatoSeleccionado ? (
          <div
            className="contendor-card-carreras"
            style={{
              width: "auto",
              width: "1000px",
              padding: "20px",
              border: "1px solid #bbbbbb",
              borderRadius: "10px",
            }}
          >
            <div
              className="botonDescargar"
              style={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "flex-start",
                padding:"0 16px"
              }}
            >
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end", width: "100%", marginBottom: 8 }}>
                <h1 className="titulos-secundarios ">
                  Tabla de pilotos
                </h1>
                {mostrarFormTotal === true ? (
                  <BotonPrincipal
                    onClick={() => mostrarFormularioTotal(false, false)}
                    texto={"Cancelar"}
                    Descargar
                    tabla
                  />
                ) : (
                  <BotonPrincipal
                    onClick={() => mostrarFormularioTotal(true, true)}
                    texto={"Armar grupo"}
                    Descargar
                    tabla
                  />
                )}
              </div>
              {!mostrarFormTotal ? (
                <hr style={{ width: "100%" }}></hr>
              ) : (
                ""
              )}
              {mostrarFormTotal && (
                <>
                  <div style={{ width: "100%" }}>
                    <hr></hr>
                  
                    <Row gutter={16} style={{ marginTop: 15, alignItems: "end" }}>
                      <Col xs={24} sm={8}>
                        <Form.Item
                          style={{
                            width: "100%",
                            // maxWidth: "300px"
                          }}
                        >
                          <InputCustom
                            idCampo="nombre_grupo"
                            nombreCampo="Nombre de grupo"
                            tipo="text"
                            elValue={tempDatosFormulario.nombre_grupo || ""}
                            elPlaceholder="Ingrese el nombre del grupo"
                            onChange={handleChange}
                            style={{
                              width: "100%",
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={8} align="middle" >
                        <Form.Item
                          style={{
                            width: "100%",
                            // maxWidth: "300px"
                          }}
                        >
                          <Checkbox 
                            onChange={onChange}
                          >
                            Solo pilotos que asisten
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={8} align="middle" >
                        <Form.Item
                          style={{
                            width: "100%",
                            // maxWidth: "300px"
                          }}
                        >
                          <Checkbox 
                            onChange={onChangePilotos}
                          >
                            Seleccionar todos los pilotos
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
              {tablaTotal.length > 0 && idCarreraSeleccionada ? (
                <TablaCompletaGrupos
                  tituloPDF={"Pilotos_totales"}
                  elScroll={elScroll}
                  columns={columnsTotal}
                  filasPorPagina={30}
                  fetchDatos={tablaTotal.length > 0 ? tablaTotal : []}
                  rowKey={"id_piloto"}
                  tituloBanner={tempDatosFormulario.nombre_grupo || "Pilotos totales"}
                  idAsociacion={sesion.id_asociacion}
                  idCategoria={idCategoriaSeleccionada}
                  modoArmarGrupo={modoArmarGrupoTotal}
                  todosPilotos={todosLosPilotos}
                  filtrarUltimaColumna={false}
                  textoDescarga={"Descargar pilotos totales"}
                  modoArmarGrupoTotales={true}
                  pagination={pagination}
                  onPaginationChange={handlePaginationChange}
                  descargaExcel={true}
                />
              ) : (
                <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", marginTop: 30 }}>
                  <p>No hay pilotos que asistan a esta carrera.</p>
                </div>
              )}
            </div>
          </div>
        ) : ""}
        {idCategoriaSeleccionada && idCarreraSeleccionada && modoVista !== MODOS.ARMAR_GRUPO_CUBIERTAS && modoVista !== MODOS.ARMAR_GRUPO_LICENCIAS ? (
          <div
              className="contendor-card-carreras"
              style={{
                width: "auto",
                width: "1000px",
                padding: "20px",
                border: "1px solid #bbbbbb",
                borderRadius: "10px",
              }}
            >
            <div
              className="contTablaPilotos"
              style={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "flex-start",
                padding:"0 16px"
              }}
            >
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end", width: "100%", marginBottom: 8 }}>
                <h1 className="titulos-secundarios ">
                  Tabla de pilotos
                </h1>
                {mostrarForm === true ? (
                  <BotonPrincipal
                    onClick={() => mostrarFormularioHandler(false, false)}
                    texto={"Cancelar"}
                    Descargar
                    tabla
                  />
                ) : (
                  <BotonPrincipal
                    onClick={() => mostrarFormularioHandler(true, true)}
                    texto={"Armar grupo"}
                    Descargar
                    tabla
                  />
                )}
              </div>
              {!mostrarForm ? (
                <hr style={{ width: "100%" }}></hr>
              ) : (
                ""
              )}
              {mostrarForm && (
                <>
                  <hr style={{ width: "100%" }}></hr>
                  <div 
                    style={{ 
                      width: "100%",
                      border: "1px solid #d5d5d5",
                      borderRadius: "6px",
                      padding: 15,
                      marginTop: 10
                    }}
                  >        
                    <h1 className="titulos-secundarios ">
                      Filtros
                    </h1>
                    <Row gutter={16} style={{ marginTop: 10, alignItems: "end" }}>
                      <Col xs={24} sm={8} align="middle">
                        <Form.Item
                          style={{
                            width: "100%",
                            border: "1px solid #d5d5d5",
                            borderRadius: "6px",
                          }}
                        >
                          <Checkbox 
                            onChange={onChange}
                          >
                            Solo pilotos que asisten
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={8} align="middle" >
                        <Form.Item
                          style={{
                            width: "100%",
                            border: "1px solid #d5d5d5",
                            borderRadius: "6px",
                          }}
                        >
                          <Checkbox 
                            onChange={onChangePilotos}
                          >
                            Seleccionar todos los pilotos
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={8} align="middle">
                        <Form.Item
                          style={{
                            width: "100%",
                            border: "1px solid #d5d5d5",
                            borderRadius: "6px",
                          }}
                        >
                          <Checkbox 
                            onChange={onChangeAdicional}
                            disabled={grupos.length > 1}
                          >
                            Agregar datos adicionales
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16} style={{ marginTop: 15 }}>
                      {grupos.length <= 2 && (
                        <Col xs={24} sm={24} align="middle" >
                          <Form.Item
                            style={{
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            
                              <Button
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "8px",
                                  padding: "10px",
                                  borderRadius: "6px",
                                  backgroundColor: "#fff",
                                  color: "#233463",
                                  fontSize: 16,
                                  border: "1px dashed #233463",
                                  cursor: "pointer",
                                }}
                                onClick={handleAgregarGrupo}
                              >
                                <PlusCircleOutlined style={{ fontSize: 30 }} />
                                Agregue otro grupo
                              </Button>
                          </Form.Item>
                        </Col>
                      )}
                      <Col xs={24} sm={24} align="middle" >
                        <Button
                            style={{
                              backgroundColor: "#BA1721",
                              color: "#FFF",
                              fontSize: 18,
                              cursor: "pointer",
                              width: "100%"
                            }}
                            onClick={exportarPDFGrupos}
                          >
                            Descargar armado de grupos
                          </Button>
                      </Col>
                    </Row>
                    <Row gutter={16} style={{ marginTop: 15 }}>
                      <Col xs={24} sm={24}>
                        <div
                        style={{
                          display: "flex",
                          gap: 16,
                          width: "100%",
                          flexWrap: "wrap",
                          justifyContent: grupos.length === 1 ? "center" : "space-between",
                        }}
                      >
                        {fetchDatos.length > 0 ? (
                          grupos.map((grupo) => {
                            const basis = isMobile
                              ? "100%"
                              : grupos.length === 1
                                ? "100%"
                                : grupos.length === 2
                                  ? "48%"
                                  : "32%";

                            return (
                              <div
                                key={grupo.id}
                                style={{
                                  flex: `0 0 ${basis}`,          // ✅ evita que se achique raro
                                  maxWidth: basis,               // ✅ no se pasa del ancho
                                  minWidth: isMobile ? "100%" : 320, // ✅ en desktop evita cards enanas
                                  boxSizing: "border-box",
                                  border: "1px solid #d5d5d5",
                                  borderRadius: 8,
                                  padding: 12,
                                  background: "#fff",
                                  overflow: "hidden",            // ✅ evita desbordes visuales
                                }}
                              >
                                <TablaArmadoGrupos
                                  fetchDatos={resultados}
                                  elScroll={elScroll}
                                  rowKey="id_piloto"
                                  todosPilotos={todosLosPilotos}
                                  mostrarInput={true}
                                  nombreGrupo={grupo.nombre}
                                  onChangeNombre={(value) =>
                                    setGrupos((prev) =>
                                      prev.map((g) =>
                                        g.id === grupo.id ? { ...g, nombre: value } : g
                                      )
                                    )
                                  }
                                  columns={
                                    esUnSoloGrupo
                                      ? (mostrarDatosAdicionales ? columns : columnsG)
                                      : columnsM
                                  }
                                  onChangeSeleccionados={(ids) =>
                                    setGrupos((prev) =>
                                      prev.map((g) =>
                                        g.id === grupo.id
                                          ? { ...g, pilotosSeleccionados: ids }
                                          : g
                                      )
                                    )
                                  }
                                  onEliminarGrupo={() =>
                                    setGrupos((prev) => prev.filter((g) => g.id !== grupo.id))
                                  }
                                  cantGrupos={grupos.length}
                                />
                              </div>
                            );
                          })
                        ) : (
                          <div style={{ width: "100%", textAlign: "center", marginTop: 30 }}>
                            <p>No hay pilotos que asistan a esta carrera.</p>
                          </div>
                        )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
              {!mostrarForm && (
                <>
                  {fetchDatos.length > 0 ? (
                    <TablaCompletaGrupos
                      tituloPDF={"Armado_de_grupos"}
                      elScroll={elScroll}
                      columns={columns}
                      filasPorPagina={30}
                      fetchDatos={resultados.length > 0 ? resultados : []}
                      rowKey={"id_piloto"}
                      tituloBanner={tempDatosFormulario.nombre_grupo || "Armado de grupo"}
                      idAsociacion={sesion.id_asociacion}
                      idCategoria={idCategoriaSeleccionada}
                      modoArmarGrupo={modoArmarGrupo}
                      todosPilotos={todosLosPilotos}
                      filtrarUltimaColumna={false}
                      textoDescarga={"Descargar armado de grupo"}
                      modoColorFondo={true}
                      ordenSalida={categoriasSeleccionadas}
                    />
                  ) : (
                    <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", marginTop: 30 }}>
                      <p>No hay pilotos que asistan a esta carrera.</p>
                    </div>
                  )}
                </>
              )}
                </div>
            </div>
        ) : (
          // <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 30 }}>
          //   <p>No hay datos disponibles para armar grupos.</p>
          // </div>
          ""
        )}
      </section>

      {/* Modal para visualizar licencia deportiva */}
      <Modal
        title={
          pilotoLicenciaSeleccionado
            ? `${pilotoLicenciaSeleccionado.apellido}, ${pilotoLicenciaSeleccionado.nombre} - ${pilotoLicenciaSeleccionado.dni}`
            : "Licencia Deportiva"
        }
        open={modalLicenciaVisible}
        onCancel={handleCerrarLicencia}
        width={800}
        centered
        footer={
          licenciaSeleccionada?.tipo_archivo === "IMAGENES" && (licenciaSeleccionada?.foto_frente || licenciaSeleccionada?.foto_dorso)
            ? [
                <BotonPrincipal
                  key="descargar"
                  texto={generandoPdfLicencia ? "Generando..." : "Descargar licencia piloto"}
                  onClick={generarPdfLicencia}
                />,
              ]
            : null
        }
      >
        {cargandoLicencia ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <div style={{ fontSize: 18, color: "#223463" }}>Cargando licencia...</div>
          </div>
        ) : licenciaSeleccionada ? (
          <div>
            {licenciaSeleccionada.tipo_archivo === "IMAGENES" &&
            (licenciaSeleccionada.foto_frente || licenciaSeleccionada.foto_dorso) ? (
              <Row gutter={[16, 16]}>
                {licenciaSeleccionada.foto_frente && (
                  <Col xs={24} sm={12}>
                    <div style={{ textAlign: "center", marginBottom: 8 }}>
                      <p style={{ fontWeight: 600, margin: 0, marginBottom: 8, color: "#223463" }}>
                        Frente
                      </p>
                      <Image
                        src={`${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${pilotoLicenciaSeleccionado?.id_campeonato || campeonatoSeleccionado}/piloto_${pilotoLicenciaSeleccionado?.id_piloto}/${licenciaSeleccionada.foto_frente}`}
                        alt="Frente licencia"
                        style={{
                          maxWidth: "100%",
                          maxHeight: 300,
                          objectFit: "contain",
                          borderRadius: 6,
                        }}
                      />
                    </div>
                  </Col>
                )}
                {licenciaSeleccionada.foto_dorso && (
                  <Col xs={24} sm={12}>
                    <div style={{ textAlign: "center", marginBottom: 8 }}>
                      <p style={{ fontWeight: 600, margin: 0, marginBottom: 8, color: "#223463" }}>
                        Dorso
                      </p>
                      <Image
                        src={`${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${pilotoLicenciaSeleccionado?.id_campeonato || campeonatoSeleccionado}/piloto_${pilotoLicenciaSeleccionado?.id_piloto}/${licenciaSeleccionada.foto_dorso}`}
                        alt="Dorso licencia"
                        style={{
                          maxWidth: "100%",
                          maxHeight: 300,
                          objectFit: "contain",
                          borderRadius: 6,
                        }}
                      />
                    </div>
                  </Col>
                )}
              </Row>
            ) : licenciaSeleccionada.tipo_archivo === "PDF" &&
              licenciaSeleccionada.licencia_pdf ? (
              <div
                style={{
                  width: "100%",
                  height: 600,
                  border: "1px solid #d5d5d5",
                  borderRadius: 6,
                  overflow: "hidden",
                }}
              >
                <iframe
                  src={`${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/IMAGENES/LICENCIAS/campeonato_${pilotoLicenciaSeleccionado?.id_campeonato || campeonatoSeleccionado}/piloto_${pilotoLicenciaSeleccionado?.id_piloto}/${licenciaSeleccionada.licencia_pdf}#toolbar=0`}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                  title="Visor de PDF"
                />
              </div>
            ) : (
              <div style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>
                <p>No hay datos de licencia disponibles.</p>
              </div>
            )}
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>
            <p>No se pudo cargar la licencia.</p>
          </div>
        )}
      </Modal>
    </>
  )
}
